var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import emptyMessages from "./assets/empty-messages.png";
import error from "./assets/error.svg";
import closeIcon from "./assets/close-icon.svg";
import mobileMenuIcon from "./assets/mobile-menu-icon.png";

// src/components/add-document-icon/add-document-icon.component.tsx
import React from "react";
var AddDocumentIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9048 9.16797C10.8105 9.16797 10.7114 9.20809 10.632 9.29394C10.5513 9.38109 10.5 9.50705 10.5 9.64575V22.3569C10.5 22.4956 10.5513 22.6215 10.632 22.7087C10.7114 22.7945 10.8105 22.8346 10.9048 22.8346H21.7619C21.8562 22.8346 21.9552 22.7945 22.0347 22.7087C22.1153 22.6215 22.1667 22.4956 22.1667 22.3569V10.0013C22.1667 9.54106 21.7936 9.16797 21.3333 9.16797H10.9048ZM9.89801 8.61477C10.1579 8.33388 10.5191 8.16797 10.9048 8.16797H21.3333C22.3459 8.16797 23.1667 8.98878 23.1667 10.0013V22.3569C23.1667 22.7368 23.0274 23.1083 22.7687 23.3878C22.5087 23.6687 22.1475 23.8346 21.7619 23.8346H10.9048C10.5191 23.8346 10.1579 23.6687 9.89801 23.3878C9.6393 23.1083 9.5 22.7368 9.5 22.3569V9.64575C9.5 9.2658 9.6393 8.89435 9.89801 8.61477ZM12.2414 13.5569C12.2414 13.2807 12.4653 13.0569 12.7414 13.0569H19.9795C20.2557 13.0569 20.4795 13.2807 20.4795 13.5569C20.4795 13.833 20.2557 14.0569 19.9795 14.0569H12.7414C12.4653 14.0569 12.2414 13.833 12.2414 13.5569ZM12.2414 16.4902C12.2414 16.214 12.4653 15.9902 12.7414 15.9902H19.9795C20.2557 15.9902 20.4795 16.214 20.4795 16.4902C20.4795 16.7663 20.2557 16.9902 19.9795 16.9902H12.7414C12.4653 16.9902 12.2414 16.7663 12.2414 16.4902ZM12.2414 19.4235C12.2414 19.1474 12.4653 18.9235 12.7414 18.9235H16.3605C16.6366 18.9235 16.8605 19.1474 16.8605 19.4235C16.8605 19.6997 16.6366 19.9235 16.3605 19.9235H12.7414C12.4653 19.9235 12.2414 19.6997 12.2414 19.4235Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "0.5",
      y: "0.5",
      width: "31",
      height: "31",
      rx: "15.5",
      stroke: "currentColor"
    }
  )
);

// src/components/document-icon/document-icon.component.tsx
import React2 from "react";
var DocumentIcon = () => /* @__PURE__ */ React2.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React2.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 1.04348C2.67157 1.04348 2 1.74425 2 2.6087V21.3913C2 22.2557 2.67157 22.9565 3.5 22.9565H20.5C21.3284 22.9565 22 22.2557 22 21.3913V2.6087C22 1.74425 21.3284 1.04348 20.5 1.04348H3.5ZM1 2.6087C1 1.16795 2.11929 0 3.5 0H20.5C21.8807 0 23 1.16795 23 2.6087V21.3913C23 22.832 21.8807 24 20.5 24H3.5C2.11929 24 1 22.832 1 21.3913V2.6087Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React2.createElement(
    "path",
    {
      d: "M12.6448 7.25C12.6448 6.83579 12.309 6.5 11.8948 6.5H5.39478C4.98056 6.5 4.64478 6.83579 4.64478 7.25C4.64478 7.66421 4.98056 8 5.39478 8H11.8948C12.309 8 12.6448 7.66421 12.6448 7.25Z",
      fill: "#FF612B"
    }
  ),
  /* @__PURE__ */ React2.createElement(
    "path",
    {
      d: "M18.6448 11.75C18.6448 11.3358 18.309 11 17.8948 11H5.39478C4.98056 11 4.64478 11.3358 4.64478 11.75C4.64478 12.1642 4.98056 12.5 5.39478 12.5H17.8948C18.309 12.5 18.6448 12.1642 18.6448 11.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React2.createElement(
    "path",
    {
      d: "M18.6448 16.25C18.6448 15.8358 18.309 15.5 17.8948 15.5H5.39478C4.98056 15.5 4.64478 15.8358 4.64478 16.25C4.64478 16.6642 4.98056 17 5.39478 17H17.8948C18.309 17 18.6448 16.6642 18.6448 16.25Z",
      fill: "currentColor"
    }
  )
);

// src/asset-map.ts
var MESSAGING_ASSETS = {
  MESSAGING_ADD_DOCUMENT_ICON: AddDocumentIcon,
  MESSAGING_DOCUMENT_ICON: DocumentIcon,
  MESSAGING_EMPTY_MESSAGES: emptyMessages,
  MESSAGING_ERROR: error,
  MESSAGING_CLOSE_ICON: closeIcon,
  MESSAGING_MOBILE_MENU_ICON: mobileMenuIcon
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(MESSAGING_ASSETS);
};

// src/constants/messaging-links.constants.ts
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
var MESSAGING_LINKS = {
  getStartNewMessage: (searchParam = "") => `${getModulePath(LEAGUE_MODULE_NAMES.messaging)}/thread${searchParam}`,
  getMessagingHome: (searchParam = "") => `${getModulePath(LEAGUE_MODULE_NAMES.messaging)}/threads${searchParam}`,
  getMessagesForThread: (threadId, searchParam = "") => `${getModulePath(
    LEAGUE_MODULE_NAMES.messaging
  )}/threads/${threadId}${searchParam}`
};
var HOME_SEARCH_PARAM = "?h=1";

// src/components/recent-message-threads/recent-message-threads.component.tsx
import React9 from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";

// src/components/threads-list/threads-list.component.tsx
import React8, { useEffect as useEffect3 } from "react";
import { Box as Box4, Flex as Flex5, Spinner as Spinner2 } from "@leagueplatform/genesis-commons";

// src/hooks/use-threads-list.hook.ts
import { useInfiniteQuery } from "@tanstack/react-query";
import {
  getThreads,
  MESSAGING_THREADS_PATH
} from "@leagueplatform/messaging-api";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";

// src/constants/feature-flags.constants.ts
var ENABLE_MESSAGING_THREADS_V2 = "enable_messaging_threads_v2";
var DISABLE_MESSAGING_QUESTIONNAIRE = "disable_messaging_questionnaire";

// src/hooks/use-threads-list.hook.ts
var useThreadsList = ({ numberOfThreads }) => {
  const { data: enableV2, isLoading } = useFeatureFlagQuery(
    ENABLE_MESSAGING_THREADS_V2
  );
  return useInfiniteQuery(
    [MESSAGING_THREADS_PATH, numberOfThreads],
    ({ pageParam }) => getThreads({ numberOfThreads, pageParam, enableV2 }),
    {
      // TODO: PCHAT-2275 check if "cacheTime" is needed here when working on this ticket
      cacheTime: 0,
      enabled: !isLoading,
      getNextPageParam: (lastPage) => {
        var _a, _b;
        if (!((_a = lastPage == null ? void 0 : lastPage.links) == null ? void 0 : _a.next) || !((_b = lastPage == null ? void 0 : lastPage.data) == null ? void 0 : _b.length)) {
          return void 0;
        }
        const paginationVersion = enableV2 ? "/v2/" : "/v1/";
        const { next } = lastPage.links;
        return next.slice(next.indexOf(paginationVersion));
      }
    }
  );
};

// src/hooks/use-get-draft-thread.hook.ts
import { useIntl } from "@leagueplatform/locales";
import {
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH2
} from "@leagueplatform/messaging-api";
import { useQueryClient } from "@tanstack/react-query";
var useGetDraftThread = () => {
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const initialDraftState = {
    subject: formatMessage({ id: "NEW_MESSAGE" }),
    participants: [],
    answers: []
  };
  const draftThread = queryClient.getQueryData([
    MESSAGING_THREADS_PATH2,
    "draft"
  ]);
  return draftThread || initialDraftState;
};

// src/components/threads-list/threads-list.component.tsx
import { ErrorState } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";

// src/hooks/use-messaging-contacts.hook.ts
import { useQuery } from "@tanstack/react-query";
import {
  getMessagingContacts,
  GET_MESSAGING_CONTACTS_PATH
} from "@leagueplatform/messaging-api";

// src/utils/normalize-participants-array.util.ts
var normalizeParticipantsArray = (participantArray) => {
  const normalizedParticipants = {
    byId: {},
    allIds: []
  };
  participantArray.forEach((participant) => {
    const { id } = participant;
    normalizedParticipants.byId[id] = participant;
    normalizedParticipants.allIds.push(id);
  });
  return normalizedParticipants;
};

// src/hooks/use-messaging-contacts.hook.ts
var useMessagingContacts = () => useQuery([GET_MESSAGING_CONTACTS_PATH], getMessagingContacts, {
  select: (data) => normalizeParticipantsArray(data.data),
  staleTime: Infinity
});

// src/components/grid-pagination-handler/grid-pagination-handler.component.tsx
import React3 from "react";
import {
  Flex,
  Spinner,
  SubtleLink,
  BodyOne
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var TryAgainButton = ({
  fetchNextPage,
  children
}) => /* @__PURE__ */ React3.createElement(
  SubtleLink,
  {
    as: "button",
    background: "none",
    border: "none",
    fontSize: "body1",
    onClick: fetchNextPage,
    textDecoration: "underline"
  },
  children
);
var GridPaginationHandler = ({
  isFetchingNextPage,
  isPaginationError,
  fetchNextPage
}) => {
  const { formatMessage } = useIntl2();
  if (isFetchingNextPage) {
    return /* @__PURE__ */ React3.createElement(
      Flex,
      {
        height: "five",
        justifyContent: "center",
        color: "decorative.brand.primary.default"
      },
      /* @__PURE__ */ React3.createElement(Spinner, { isLoading: true })
    );
  }
  const buttonWrapper = (text) => /* @__PURE__ */ React3.createElement(TryAgainButton, { fetchNextPage }, text);
  if (isPaginationError) {
    return /* @__PURE__ */ React3.createElement(Flex, { justifyContent: "center", marginY: "oneAndHalf" }, /* @__PURE__ */ React3.createElement(BodyOne, { as: "span", color: "onSurface.text.critical" }, formatMessage(
      { id: "MESSAGES_PAGINATION_ERROR" },
      {
        button: buttonWrapper
      }
    )));
  }
  return null;
};

// src/pages/utils/get-flattened-thread-data.util.tsx
var getFlattenedThreadData = (threadsData) => {
  let flattenedThreadsData;
  if (threadsData == null ? void 0 : threadsData.pages) {
    flattenedThreadsData = threadsData.pages.reduce((acc, page) => {
      if (page.data) {
        return acc.concat(page.data);
      }
      return acc;
    }, []);
  }
  return flattenedThreadsData;
};

// src/components/threads-list/threads-list.component.tsx
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";

// src/components/threads-list/thread-preview/thread-preview.component.tsx
import React6, { useEffect } from "react";
import {
  LinkLegacy as Link,
  useNavigateLegacy as useNavigate,
  useParamsLegacy as useParams
} from "@leagueplatform/routing";
import { useIntl as useIntl5 } from "react-intl";
import {
  Box as Box2,
  css,
  Flex as Flex3,
  genesisStyled as genesisStyled2,
  BodyOne as BodyOne2,
  VisuallyHidden
} from "@leagueplatform/genesis-commons";

// src/components/participants-avatar/participants-avatar.tsx
import * as React4 from "react";
import { Flex as Flex2, Box, genesisStyled } from "@leagueplatform/genesis-commons";
import { Avatar } from "@leagueplatform/web-common-components";
var MultipleParticipants = genesisStyled(Flex2)`
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 48px;
  div {
    position: absolute;
  }
  div:first-of-type {
    bottom: 0;
    inset-inline-start: 0;
  }
  div:last-of-type {
    top: 0;
    inset-inline-end: 0;
  }
`;
function ParticipantsAvatar({ participants }) {
  var _a, _b, _c;
  const maxAvatars = 2;
  return /* @__PURE__ */ React4.createElement(Box, { width: "three", height: "three" }, participants.length > 1 ? /* @__PURE__ */ React4.createElement(MultipleParticipants, null, participants.slice(0, maxAvatars).map((participant) => /* @__PURE__ */ React4.createElement(
    Avatar,
    {
      key: participant.id,
      userInitials: participant.initials,
      imageSrc: participant == null ? void 0 : participant.photoUrl,
      width: "two",
      height: "two",
      fontSize: "caption"
    }
  ))) : /* @__PURE__ */ React4.createElement(
    Avatar,
    {
      key: (_a = participants[0]) == null ? void 0 : _a.initials,
      userInitials: (_b = participants[0]) == null ? void 0 : _b.initials,
      imageSrc: (_c = participants[0]) == null ? void 0 : _c.photoUrl,
      width: "three",
      height: "three"
    }
  ));
}

// src/components/timestamp/timestamp.tsx
import * as React5 from "react";
import { BodyTwoSecondary } from "@leagueplatform/genesis-commons";
import { isToday, differenceInCalendarDays } from "date-fns";
import {
  SHORT_WEEKDAY_FORMAT,
  SHORT_MONTH_FORMAT
} from "@leagueplatform/web-common";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
var useGetFormattedLastActiveTimestamp = (lastActive) => {
  const { formatTime, formatDate } = useIntl3();
  const convertedTimestamp = new Date(lastActive);
  switch (true) {
    case isToday(convertedTimestamp):
      return formatTime(convertedTimestamp);
    case differenceInCalendarDays(/* @__PURE__ */ new Date(), convertedTimestamp) <= 6:
      return formatDate(convertedTimestamp, SHORT_WEEKDAY_FORMAT);
    default:
      return formatDate(convertedTimestamp, SHORT_MONTH_FORMAT);
  }
};
function TimeStamp({ lastActive }) {
  const lastActiveTimeStamp = useGetFormattedLastActiveTimestamp(lastActive);
  return /* @__PURE__ */ React5.createElement(BodyTwoSecondary, null, lastActiveTimeStamp);
}

// src/utils/track-messaging-analytics.util.ts
import {
  trackAnalyticsEvent,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA
} from "@leagueplatform/analytics";
var baseAnalyticsObj = {
  product_area: PRODUCT_AREA.GET_CARE,
  sub_product_area: SUB_PRODUCT_AREA.MESSAGING
};
var trackMessagingAnalyticsEvent = (eventType, analyticsProps) => {
  trackAnalyticsEvent(eventType, __spreadValues(__spreadValues({}, baseAnalyticsObj), analyticsProps));
};

// src/components/threads-list/thread-preview/thread-preview.component.tsx
import { EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";

// src/pages/utils/get-participant-firstnames.util.ts
var getParticipantFirstNames = (participants) => participants.map((participant) => participant.firstName);

// src/hooks/use-search-params.hook.ts
import { useLocationLegacy as useLocation } from "@leagueplatform/routing";
import { useMemo } from "react";
function useSearchParams() {
  const { search } = useLocation();
  return useMemo(
    () => new URLSearchParams(search),
    [search]
  );
}

// src/hooks/use-get-user-profile.hook.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
var useGetUserProfile = () => useQuery2([GET_USER_PROFILE_MESSAGE_TYPE], () => getUserProfile(), {
  staleTime: Infinity
});

// src/hooks/use-remove-current-user.hook.ts
function useRemoveCurrentUser(participants = []) {
  const { data: userProfileData } = useGetUserProfile();
  const currentUserId = userProfileData == null ? void 0 : userProfileData.user_id;
  return participants.filter((participant) => participant.id !== currentUserId);
}

// src/components/threads-list/thread-preview/use-message-thread-display-text.hook.ts
import { useIntl as useIntl4 } from "react-intl";
var useMessageThreadDisplayText = (thread) => {
  var _a;
  const { formatMessage } = useIntl4();
  const { data: userProfileData } = useGetUserProfile();
  const { latestMessage, participants } = thread;
  if (latestMessage.data.text) {
    return latestMessage.data.text;
  }
  if (((_a = latestMessage.data.documents) == null ? void 0 : _a.data.length) && latestMessage.data.sender) {
    const { id: senderId } = latestMessage.data.sender.data;
    const isMessageFromCurrentUser = (userProfileData == null ? void 0 : userProfileData.user_id) === senderId;
    const sender = participants.data.find(
      (participant) => senderId === participant.id
    );
    const messageSender = isMessageFromCurrentUser ? formatMessage({ id: "YOU" }) : sender == null ? void 0 : sender.firstName;
    return formatMessage(
      { id: "USER_ADDED_DOCUMENT" },
      { user: messageSender || "" }
    );
  }
  return formatMessage({ id: "NEW_MESSAGE_DEFAULT" });
};

// src/components/threads-list/generate-draft-thread-display-data.util.ts
var DRAFT_PLACEHOLDER_ID = "draft-thread-placeholder";
var generateDraftThreadDisplayData = (draftThread, messagingContactsData, isQuestionnaireDisabled) => {
  var _a, _b;
  if (!((_a = draftThread == null ? void 0 : draftThread.participants) == null ? void 0 : _a.length) && !((_b = draftThread == null ? void 0 : draftThread.answers) == null ? void 0 : _b.length)) {
    return void 0;
  }
  const { subject, participants } = draftThread;
  const draftParticipantsList = participants.map(
    ({ id }) => messagingContactsData.byId[id]
  );
  if (!isQuestionnaireDisabled) {
    const draftParticipant = {
      id: "draft-thread-participant",
      type: "participant",
      firstName: "New Message",
      initials: "NM",
      name: "New Message",
      role: "family-member"
    };
    draftParticipantsList.push(draftParticipant);
  }
  return {
    id: DRAFT_PLACEHOLDER_ID,
    isRead: true,
    latestMessage: {
      data: {
        sender: { data: participants[0] },
        sentAt: "",
        id: "draft-thread-new-message-id",
        type: "message"
      }
    },
    participants: {
      data: draftParticipantsList
    },
    subject,
    type: "thread"
  };
};

// src/components/threads-list/thread-preview/thread-preview.component.tsx
var StyledGridRow = genesisStyled2(Flex3)(
  ({ isSelected }) => css(__spreadProps(__spreadValues({
    alignItems: "center",
    borderBottomWidth: "thin",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomStyle: "solid",
    transition: "background-color .2s"
  }, isSelected && { backgroundColor: "interactive.background.pressed" }), {
    "&:last-child": {
      borderBottom: "none"
    },
    "&:hover": {
      backgroundColor: "interactive.background.hovered"
    },
    "&:active": {
      backgroundColor: "interactive.background.pressed"
    }
  }))
);
var OverflowText = genesisStyled2(BodyOne2)`
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
var ThreadPreview = ({
  thread,
  hasFocus,
  isEntryPoint,
  threadGridHasFocus
}) => {
  const { threadId } = useParams();
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const displayText = useMessageThreadDisplayText(thread);
  const cellRef = React6.useRef(null);
  const { formatMessage } = useIntl5();
  const firstRenderRef = React6.useRef(true);
  useEffect(() => {
    var _a;
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    if (hasFocus && threadGridHasFocus) {
      (_a = cellRef.current) == null ? void 0 : _a.focus();
    }
  }, [hasFocus, threadGridHasFocus]);
  const {
    id,
    subject,
    participants: { data: participantsData },
    isRead,
    latestMessage: {
      data: { sentAt }
    },
    threadAvatars
  } = thread;
  const userNames = getParticipantFirstNames(participantsData);
  const filteredParticipants = useRemoveCurrentUser(participantsData);
  let participantsAvatar;
  if (threadAvatars) {
    participantsAvatar = threadAvatars.map((avatar) => ({
      id: avatar.initials,
      // TODO: PCHAT-2715 use avatar id here
      initials: avatar.initials,
      photoUrl: avatar.url
    }));
  } else {
    participantsAvatar = filteredParticipants.map((avatar) => ({
      id: avatar.id,
      initials: avatar.initials,
      photoUrl: avatar.photoUrl
    }));
  }
  const isDraft = id === DRAFT_PLACEHOLDER_ID;
  const isSelected = threadId ? id === threadId : isDraft;
  const includeHomeParam = searchParams.get("h") || isEntryPoint;
  const searchParam = includeHomeParam ? HOME_SEARCH_PARAM : "";
  const toLink = isDraft ? MESSAGING_LINKS.getMessagesForThread("", searchParam) : MESSAGING_LINKS.getMessagesForThread(id, searchParam);
  return /* @__PURE__ */ React6.createElement(
    StyledGridRow,
    {
      key: id,
      isSelected,
      role: "row",
      className: `thread-preview-row ${isSelected ? "selected" : ""}`
    },
    /* @__PURE__ */ React6.createElement(Box2, { role: "gridcell", width: "100%", padding: 2 }, /* @__PURE__ */ React6.createElement(
      Box2,
      {
        as: Link,
        backgroundColor: "transparent",
        border: "none",
        display: "inline-block",
        paddingX: { _: "half", phone: "oneAndHalf" },
        paddingY: "one",
        textAlign: "start",
        textDecoration: "none",
        height: "100%",
        width: "100%",
        tabIndex: hasFocus ? 0 : -1,
        ref: cellRef,
        css: css({
          position: "relative",
          "::before": {
            content: '""',
            position: "absolute",
            top: "0px",
            insetInlineStart: "0px",
            insetInlineEnd: "0px",
            bottom: "0px",
            borderRadius: "small"
          },
          ":hover": {
            cursor: "pointer"
          },
          ":focus-visible": {
            outline: 0,
            borderWidth: "thin",
            borderColor: "interactive.focus.outer"
          },
          ":focus-visible::before": {
            boxShadow: "focusOutline"
          }
        }),
        onClick: () => {
          navigate(toLink, { replace: true });
          trackMessagingAnalyticsEvent(EVENT_NAME2.BUTTON_CLICKED, {
            screen_name: "messages" /* MESSAGES */,
            detail: "thread"
          });
        },
        "aria-current": isSelected ? "page" : "false"
      },
      /* @__PURE__ */ React6.createElement(Flex3, null, /* @__PURE__ */ React6.createElement(Box2, { marginInlineEnd: "threeQuarters", minWidth: "three" }, /* @__PURE__ */ React6.createElement(ParticipantsAvatar, { participants: participantsAvatar })), /* @__PURE__ */ React6.createElement(Box2, { width: "calc(100% - 60px)" }, /* @__PURE__ */ React6.createElement(Flex3, { alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ React6.createElement(OverflowText, { fontSize: "subtitle1", fontWeight: "bold" }, subject || userNames.join(", ")), !isRead && /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(VisuallyHidden, null, formatMessage({ id: "UNREAD" })), /* @__PURE__ */ React6.createElement(
        Box2,
        {
          backgroundColor: "highlight.icon",
          borderRadius: "circle",
          marginInlineStart: "half",
          minWidth: "threeQuarters",
          size: "threeQuarters"
        }
      ))), /* @__PURE__ */ React6.createElement(Flex3, { alignItems: "flex-start", justifyContent: "space-between" }, /* @__PURE__ */ React6.createElement(
        OverflowText,
        {
          fontSize: "body2",
          fontWeight: isRead ? "regular" : "bold",
          fontStyle: isDraft ? "italic" : "regular"
        },
        displayText
      ), sentAt && /* @__PURE__ */ React6.createElement(TimeStamp, { lastActive: sentAt }))))
    ))
  );
};

// src/components/threads-list/empty-threads-list/empty-threads-list.component.tsx
import React7 from "react";
import { LinkLegacy as Link2 } from "@leagueplatform/routing";
import {
  CoverImage,
  Flex as Flex4,
  HeadingThree,
  BodyOne as BodyOne3,
  HeadingFour,
  PrimaryButton,
  Box as Box3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME3, SCREEN_NAMES as SCREEN_NAMES2 } from "@leagueplatform/analytics";
var EMPTY_MESSAGES_IMAGE_SIZE = 136;
var EmptyThreadsList = ({ isEntryPoint }) => {
  const { formatMessage } = useIntl6();
  const emptyMessages2 = handleStaticAsset(
    "MESSAGING_EMPTY_MESSAGES" /* MESSAGING_EMPTY_MESSAGES */
  );
  if (isEntryPoint) {
    return /* @__PURE__ */ React7.createElement(Box3, { padding: "oneAndHalf" }, /* @__PURE__ */ React7.createElement(Flex4, { alignItems: "center" }, /* @__PURE__ */ React7.createElement(Box3, null, /* @__PURE__ */ React7.createElement(HeadingFour, { as: "h3" }, formatMessage({ id: "NO_MESSAGES_YET" })), /* @__PURE__ */ React7.createElement(BodyOne3, { marginTop: "half", marginBottom: "one" }, formatMessage({ id: "NO_MESSAGES_DETAIL" }))), /* @__PURE__ */ React7.createElement(
      CoverImage,
      {
        src: emptyMessages2,
        alt: "",
        minWidth: EMPTY_MESSAGES_IMAGE_SIZE,
        size: EMPTY_MESSAGES_IMAGE_SIZE,
        marginInlineStart: "one"
      }
    )), /* @__PURE__ */ React7.createElement(
      PrimaryButton,
      {
        as: Link2,
        to: MESSAGING_LINKS.getStartNewMessage(HOME_SEARCH_PARAM),
        textDecoration: "none",
        onClick: () => trackMessagingAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          screen_name: SCREEN_NAMES2.HOME_SCREEN,
          detail: "start a new message"
        })
      },
      formatMessage({ id: "START_A_NEW_MESSAGE" })
    ));
  }
  return /* @__PURE__ */ React7.createElement(
    Flex4,
    {
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      paddingX: "one",
      textAlign: "center"
    },
    /* @__PURE__ */ React7.createElement(CoverImage, { src: emptyMessages2, alt: "", size: EMPTY_MESSAGES_IMAGE_SIZE }),
    /* @__PURE__ */ React7.createElement(HeadingThree, { as: "h2", marginTop: "oneAndHalf" }, formatMessage({ id: "NO_MESSAGES_HEADING" })),
    /* @__PURE__ */ React7.createElement(BodyOne3, { marginTop: "half" }, formatMessage({ id: "NO_MESSAGES_DESCRIPTION" }))
  );
};

// src/hooks/use-grid-navigation/use-grid-navigation.hook.tsx
import { useState, useRef, useEffect as useEffect2 } from "react";

// src/constants/messaging.constants.ts
var MESSAGING_BANNER_FLAG = "messaging_banner_enabled";
var ALLOWED_EVENT_KEYS = /* @__PURE__ */ ((ALLOWED_EVENT_KEYS2) => {
  ALLOWED_EVENT_KEYS2["ARROW_RIGHT"] = "ArrowRight";
  ALLOWED_EVENT_KEYS2["ARROW_LEFT"] = "ArrowLeft";
  ALLOWED_EVENT_KEYS2["ARROW_UP"] = "ArrowUp";
  ALLOWED_EVENT_KEYS2["ARROW_DOWN"] = "ArrowDown";
  ALLOWED_EVENT_KEYS2["HOME"] = "Home";
  ALLOWED_EVENT_KEYS2["END"] = "End";
  ALLOWED_EVENT_KEYS2["PAGE_UP"] = "PageUp";
  ALLOWED_EVENT_KEYS2["PAGE_DOWN"] = "PageDown";
  return ALLOWED_EVENT_KEYS2;
})(ALLOWED_EVENT_KEYS || {});

// src/hooks/use-grid-navigation/handle-keydown-events.util.ts
var pageAdjustment = 4;
var handleKeydownEvents = ({
  event,
  gridParentNode,
  currentGridCell,
  setCurrentGridCell,
  maxGridSize,
  paginationProps = {}
}) => {
  const { fetchNextPage, paginationDirection, canFetchMessages } = paginationProps;
  const allowedEventKeys = Object.values(ALLOWED_EVENT_KEYS);
  if (!allowedEventKeys.includes(event.key))
    return;
  if (!(gridParentNode == null ? void 0 : gridParentNode.contains(document.activeElement)))
    return;
  event.preventDefault();
  const { row, col } = currentGridCell;
  const { totalRows, totalCols } = maxGridSize;
  switch (event.key) {
    case "ArrowRight" /* ARROW_RIGHT */: {
      if (col < totalCols - 1) {
        setCurrentGridCell({
          row,
          col: col + 1
        });
      }
      break;
    }
    case "ArrowLeft" /* ARROW_LEFT */: {
      if (col > 0) {
        setCurrentGridCell({
          row,
          col: col - 1
        });
      }
      break;
    }
    case "ArrowDown" /* ARROW_DOWN */: {
      const isDownFetchable = row === totalRows - 1 && paginationDirection === "down" /* DOWN */;
      if (isDownFetchable && canFetchMessages) {
        fetchNextPage == null ? void 0 : fetchNextPage();
      }
      if (row < totalRows - 1) {
        setCurrentGridCell({
          row: row + 1,
          col
        });
      }
      break;
    }
    case "ArrowUp" /* ARROW_UP */: {
      const isUpFetchable = row === 0 && paginationDirection === "up" /* UP */;
      if (isUpFetchable && canFetchMessages) {
        fetchNextPage == null ? void 0 : fetchNextPage();
      }
      if (row > 0) {
        setCurrentGridCell({
          row: row - 1,
          col
        });
      }
      break;
    }
    case "Home" /* HOME */: {
      if (col > 0) {
        setCurrentGridCell({
          row,
          col: 0
        });
      }
      break;
    }
    case "End" /* END */: {
      if (col < totalCols - 1) {
        setCurrentGridCell({
          row,
          col: totalCols - 1
        });
      }
      break;
    }
    case "PageUp" /* PAGE_UP */: {
      const rowMinusAdjustment = row - pageAdjustment;
      const newrow = rowMinusAdjustment >= 0 ? rowMinusAdjustment : 0;
      setCurrentGridCell({
        row: newrow,
        col
      });
      break;
    }
    case "PageDown" /* PAGE_DOWN */: {
      const rowPlusAdjustment = row + pageAdjustment;
      const newrow = rowPlusAdjustment < totalRows ? rowPlusAdjustment : totalRows - 1;
      setCurrentGridCell({
        row: newrow,
        col
      });
      break;
    }
    default:
  }
};

// src/hooks/use-grid-navigation/use-grid-navigation.hook.tsx
var useGridNavigation = (maxGridSize, paginationProps, initialElement) => {
  const [currentGridCell, setCurrentGridCell] = useState(
    initialElement != null ? initialElement : { row: 0, col: 0 }
  );
  const gridRef = useRef(null);
  useEffect2(() => {
    const eventHandler = (event) => handleKeydownEvents({
      event,
      gridParentNode: gridRef.current,
      currentGridCell,
      setCurrentGridCell,
      maxGridSize,
      paginationProps
    });
    document.addEventListener("keydown" /* KEYDOWN */, eventHandler);
    return () => document.removeEventListener("keydown" /* KEYDOWN */, eventHandler);
  }, [currentGridCell, maxGridSize, paginationProps]);
  return { gridRef, currentGridCell };
};

// src/components/threads-list/threads-list.component.tsx
var GRID_LABEL_ID = "gridLabelId";
var ERROR_MAX_WIDTH = "80%";
var LOADER_MIN_HEIGHT = "200px";
var fetchOnScroll = (scrollableElement, fetchNextPage) => {
  const { scrollTop, scrollHeight, clientHeight } = scrollableElement;
  if (scrollTop + clientHeight + 5 >= scrollHeight) {
    fetchNextPage();
  }
};
var ThreadsGrid = ({
  threads,
  isEntryPoint,
  fetchNextPage,
  isFetchingNextPage,
  isPaginationError,
  threadFromDraft
}) => {
  const { formatMessage } = useIntl7();
  const [threadGridHasFocus, setThreadGridHasFocus] = React8.useState(false);
  const isTabletAndBelow = useMediaQuery(queryHelpers.down("laptop"));
  const slicedThreads = isEntryPoint ? threads.slice(0, 3) : threads;
  const totalThreads = (slicedThreads == null ? void 0 : slicedThreads.length) || 0;
  const totalRows = threadFromDraft ? totalThreads + 1 : totalThreads;
  const { gridRef, currentGridCell } = useGridNavigation({
    totalRows,
    totalCols: 1
  });
  const canFetchMessages = !isFetchingNextPage && !isPaginationError;
  useEffect3(() => {
    var _a;
    const currentGridElement = (_a = gridRef.current) != null ? _a : document.body;
    const scrollListener = () => {
      if (canFetchMessages) {
        fetchOnScroll(currentGridElement, fetchNextPage);
      }
    };
    currentGridElement.addEventListener("scroll" /* SCROLL */, scrollListener);
    return () => currentGridElement.removeEventListener(
      "scroll" /* SCROLL */,
      scrollListener
    );
  });
  return /* @__PURE__ */ React8.createElement(
    Box4,
    {
      overflowY: isEntryPoint || isTabletAndBelow ? "initial" : "auto",
      "aria-labelledby": GRID_LABEL_ID,
      ref: gridRef,
      role: "grid",
      onFocus: () => {
        setThreadGridHasFocus(true);
      },
      onBlur: () => {
        setThreadGridHasFocus(false);
      }
    },
    threadFromDraft && /* @__PURE__ */ React8.createElement(
      ThreadPreview,
      {
        key: threadFromDraft.id,
        thread: __spreadProps(__spreadValues({}, threadFromDraft), {
          subject: formatMessage({ id: "NEW_MESSAGE" })
        }),
        hasFocus: currentGridCell.row === 0,
        isEntryPoint
      }
    ),
    slicedThreads.map((thread, index) => /* @__PURE__ */ React8.createElement(
      ThreadPreview,
      {
        key: thread.id,
        thread,
        hasFocus: (
          // In the case where we have a draft thread, we add 1 to the index in order for the
          // focus check to account for the extra row
          threadFromDraft ? currentGridCell.row === index + 1 : currentGridCell.row === index
        ),
        isEntryPoint,
        threadGridHasFocus
      }
    )),
    /* @__PURE__ */ React8.createElement(
      GridPaginationHandler,
      {
        isFetchingNextPage,
        isPaginationError,
        fetchNextPage
      }
    )
  );
};
var ThreadsList = ({
  isEntryPoint,
  numberOfThreads = 15,
  isQuestionnaireDisabled
}) => {
  const {
    data: threadsData,
    isLoading,
    error: error2,
    fetchNextPage,
    isFetchingNextPage,
    isRefetching
  } = useThreadsList({ numberOfThreads });
  const { formatMessage } = useIntl7();
  const draftThread = useGetDraftThread();
  const { data: messagingContactsData } = useMessagingContacts();
  const flattenedThreadsData = getFlattenedThreadData(threadsData);
  if (isLoading) {
    return /* @__PURE__ */ React8.createElement(
      Flex5,
      {
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "center",
        color: "decorative.brand.primary.default",
        minHeight: LOADER_MIN_HEIGHT
      },
      /* @__PURE__ */ React8.createElement(Spinner2, { isLoading: true })
    );
  }
  if (error2 && (flattenedThreadsData == null ? void 0 : flattenedThreadsData.length)) {
    return /* @__PURE__ */ React8.createElement(
      ThreadsGrid,
      {
        isEntryPoint,
        threads: flattenedThreadsData,
        fetchNextPage,
        isFetchingNextPage,
        isPaginationError: true
      }
    );
  }
  if (error2 || !flattenedThreadsData) {
    const errorImage = handleStaticAsset2(
      "MESSAGING_ERROR" /* MESSAGING_ERROR */
    );
    return /* @__PURE__ */ React8.createElement(
      Flex5,
      {
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingY: "one"
      },
      /* @__PURE__ */ React8.createElement(Box4, { maxWidth: ERROR_MAX_WIDTH }, /* @__PURE__ */ React8.createElement(
        ErrorState,
        {
          imageSrc: errorImage,
          hideButton: true,
          headingString: formatMessage({ id: "GENERIC_MESSAGING_ERROR" }),
          error: error2
        }
      ))
    );
  }
  const threadFromDraft = generateDraftThreadDisplayData(
    draftThread,
    messagingContactsData,
    isQuestionnaireDisabled
  );
  if (!threadFromDraft && !flattenedThreadsData.length) {
    return /* @__PURE__ */ React8.createElement(EmptyThreadsList, { isEntryPoint });
  }
  return /* @__PURE__ */ React8.createElement(
    ThreadsGrid,
    {
      isEntryPoint,
      threads: flattenedThreadsData,
      fetchNextPage,
      isFetchingNextPage: (
        /*
          Hide loading in Homepage when is refreshing but in the Messaging page,
          show the loading for both cases.
          TODO: PCHAT-2275 Move loading to parent component and this won't be necessary
        */
        isEntryPoint ? isFetchingNextPage : isRefetching || isFetchingNextPage
      ),
      threadFromDraft
    }
  );
};

// src/components/recent-message-threads/recent-message-threads.component.tsx
import { Flex as Flex6, HeadingTwo, Box as Box5 } from "@leagueplatform/genesis-commons";
import { GenesisRouterLink } from "@leagueplatform/web-common-components";
var RecentMessageThreads = () => {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React9.createElement(Flex6, { flexDirection: "column", className: "recent-messages-threads-container" }, /* @__PURE__ */ React9.createElement(Flex6, { alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ React9.createElement(HeadingTwo, { id: GRID_LABEL_ID }, formatMessage({ id: "RECENT_MESSAGES" })), /* @__PURE__ */ React9.createElement(
    GenesisRouterLink,
    {
      to: MESSAGING_LINKS.getMessagingHome(HOME_SEARCH_PARAM),
      fontWeight: "bold",
      "aria-label": formatMessage({ id: "VIEW_ALL_MESSAGE_THREADS" })
    },
    formatMessage({ id: "VIEW_ALL" })
  )), /* @__PURE__ */ React9.createElement(
    Box5,
    {
      borderColor: "onSurface.border.subdued",
      borderWidth: "thin",
      borderStyle: "solid",
      borderRadius: "medium",
      marginTop: "oneAndHalf"
    },
    /* @__PURE__ */ React9.createElement(ThreadsList, { isEntryPoint: true, numberOfThreads: 3 })
  ));
};

// src/messaging.routes.tsx
import React37 from "react";
import {
  Routes,
  Route,
  NavigateLegacy as Navigate
} from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery6 } from "@leagueplatform/user-profile-api";
import { LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES4, getModulePath as getModulePath4 } from "@leagueplatform/core";

// src/pages/messages-page.page.tsx
import React34, { useState as useState7, useEffect as useEffect16, useRef as useRef3 } from "react";
import {
  useNavigateLegacy as useNavigate4,
  useParamsLegacy as useParams9
} from "@leagueplatform/routing";
import {
  Flex as Flex21,
  Spinner as Spinner6,
  genesisStyled as genesisStyled12,
  css as css9
} from "@leagueplatform/genesis-commons";
import { Box as Box23 } from "@leagueplatform/genesis-core";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { ErrorState as ErrorState5 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";

// src/hooks/use-get-messaging-config.hook.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getMessagingConfig
} from "@leagueplatform/messaging-api";
var useGetMessagingConfig = () => useQuery3(
  ["GET_MESSAGING_CONFIG"],
  () => getMessagingConfig(),
  {
    staleTime: Infinity
  }
);

// src/hooks/use-messages-page.hook.ts
var useMessagesPage = ({ numberOfThreads }) => {
  const {
    data: userProfileData,
    isLoading: isLoadingProfile,
    error: userProfileError
  } = useGetUserProfile();
  const {
    data: contactsData,
    isLoading: isLoadingContactsData,
    error: contactsDataError
  } = useMessagingContacts();
  const {
    data: threadsData,
    isLoading: isThreadsDataLoading,
    isError: isThreadsDataError,
    error: isThreadsDataErrorType
  } = useThreadsList({ numberOfThreads });
  const {
    isLoading: isLoadingMessagingConfig,
    data: messagingConfig,
    isError: messagingConfigError,
    error: messagingConfigErrorType
  } = useGetMessagingConfig();
  return {
    messagingConfig,
    threadsData,
    isLoading: isLoadingProfile || isLoadingContactsData || isThreadsDataLoading || isLoadingMessagingConfig,
    isError: isThreadsDataError || userProfileError || contactsDataError || !contactsData || !(userProfileData == null ? void 0 : userProfileData.user_id) || messagingConfigError,
    error: [
      userProfileError,
      contactsDataError,
      messagingConfigErrorType,
      isThreadsDataErrorType
    ]
  };
};

// src/hooks/use-delete-draft-thread.hook.ts
import { MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH3 } from "@leagueplatform/messaging-api";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
var useDeleteDraftThread = () => {
  const queryClient = useQueryClient2();
  const deleteDraftThread = () => queryClient.removeQueries({
    queryKey: [MESSAGING_THREADS_PATH3, "draft"],
    exact: true
  });
  return deleteDraftThread;
};

// src/hooks/use-new-message-event.hook.ts
import { useEffect as useEffect4 } from "react";
import { useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import {
  THREAD_MESSAGES_PATH,
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH4
} from "@leagueplatform/messaging-api";
import { ReconnectingSocketController } from "@leagueplatform/league-socket";
function useNewMessageEvent() {
  const queryClient = useQueryClient3();
  useEffect4(() => {
    const removeEventHandler = ReconnectingSocketController.addEventHandler(
      (event) => {
        if (event.message_type === "thread_messages_created") {
          queryClient.invalidateQueries([
            THREAD_MESSAGES_PATH,
            event.info.thread_id
          ]);
          queryClient.invalidateQueries([MESSAGING_THREADS_PATH4]);
        }
      }
    );
    return () => {
      removeEventHandler();
    };
  }, [queryClient]);
}

// src/hooks/use-post-start-async-messaging.hook.ts
import { useMutation } from "@tanstack/react-query";
import {
  postStartAsyncMessaging
} from "@leagueplatform/messaging-api";
var usePostStartAsyncMessaging = () => useMutation(
  (answers) => postStartAsyncMessaging(answers)
);

// src/pages/messages-page.page.tsx
import { useFeatureFlagQuery as useFeatureFlagQuery5 } from "@leagueplatform/user-profile-api";

// src/components/page-error-context/page-error-context.tsx
import React10, { createContext, useState as useState2, useContext } from "react";
var PageErrorContext = createContext([void 0, () => {
}]);
function PageErrorProvider({ children }) {
  const config = useState2(void 0);
  return /* @__PURE__ */ React10.createElement(PageErrorContext.Provider, { value: config }, children);
}
function usePageError() {
  const [value, setValue] = useContext(PageErrorContext);
  const setConfig = React10.useCallback(
    (config) => {
      setValue(config);
    },
    [setValue]
  );
  return [value, setConfig];
}

// src/pages/messages-page.page.tsx
import { useIntl as useIntl26 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME14 } from "@leagueplatform/analytics";

// src/pages/components/message-header/message-header.component.tsx
import React14 from "react";
import { useParamsLegacy as useParams3 } from "@leagueplatform/routing";
import {
  Flex as Flex9,
  Spinner as Spinner3,
  CoverImage as CoverImage2,
  BodyOne as BodyOne4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";

// src/hooks/use-message-thread-details.hook.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
import {
  getThreadDetails,
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH5
} from "@leagueplatform/messaging-api";
var useMessageThreadDetails = (threadId) => useQuery4(
  [MESSAGING_THREADS_PATH5, threadId],
  () => getThreadDetails(threadId),
  {
    // we need to call this endpoint a lot for the same info that won't change
    // once a thread has been created. Therefore, we shouldn't need to refetch
    // unless we explicitly want to
    staleTime: Infinity,
    // When a brand new thread is created the threadId isn't created (yet)
    // causing this query to load for an extended period of time, preventing the
    // user from sending a message.
    enabled: !!threadId
  }
);

// src/hooks/use-get-thread-info-config.hook.ts
var useGetThreadInfoConfig = () => {
  const { data } = useGetMessagingConfig();
  const getAttributeByName = (attrName) => {
    var _a, _b;
    const attrData = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.find(
      (config) => {
        var _a2;
        return ((_a2 = config == null ? void 0 : config.attributes) == null ? void 0 : _a2.name) === attrName;
      }
    );
    return (_b = attrData == null ? void 0 : attrData.attributes) == null ? void 0 : _b.value;
  };
  const threadInfoEnabled = getAttributeByName("THREAD_INFO_ENABLED") === "true";
  return {
    threadInfoEnabled
  };
};

// src/hooks/use-get-messaging-style.hook.ts
var styleConfigName = "MESSAGING_THREAD_UI_STYLE";
var useGetMessagingStyle = () => {
  var _a, _b;
  const { data } = useGetMessagingConfig();
  const messagingStyleConfig = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.find(
    (config) => {
      var _a2;
      return ((_a2 = config == null ? void 0 : config.attributes) == null ? void 0 : _a2.name) === styleConfigName;
    }
  );
  const messagingStyle = (_b = messagingStyleConfig == null ? void 0 : messagingStyleConfig.attributes) == null ? void 0 : _b.value;
  return {
    messagingStyle
  };
};

// src/utils/string-to-boolean.util.ts
var stringToBoolean = (value) => {
  if ((value == null ? void 0 : value.toLowerCase()) === "false") {
    return false;
  }
  if ((value == null ? void 0 : value.toLowerCase()) === "true") {
    return true;
  }
  return null;
};

// src/utils/get-config-by-name.util.ts
var getConfigByName = (configName, configArr, format) => {
  const attrData = configArr == null ? void 0 : configArr.find(
    (config) => (config == null ? void 0 : config.name) === configName
  );
  let configValue = attrData == null ? void 0 : attrData.value;
  if (format === "bool") {
    configValue = stringToBoolean(configValue);
  }
  if (format === "number" && (configValue == null ? void 0 : configValue.length) > 0) {
    configValue = Number(configValue);
  }
  if (configValue === void 0) {
    configValue = null;
  }
  return configValue;
};

// src/utils/get-config-override.util.ts
var getConfigOverride = ({
  defaultConfigValue,
  configName,
  fhirResponseConfigs,
  threadConfigs,
  format = "string"
}) => {
  const flattenedFhirResponseConfigs = fhirResponseConfigs == null ? void 0 : fhirResponseConfigs.map(
    (config) => config.attributes
  );
  const configValueBasedOnQuestionnaire = getConfigByName(
    configName,
    flattenedFhirResponseConfigs,
    format
  );
  const configValueBasedOnThread = getConfigByName(
    configName,
    threadConfigs,
    format
  );
  let configValue = configValueBasedOnQuestionnaire;
  if (configValue === null) {
    configValue = defaultConfigValue;
  }
  if (configValueBasedOnThread !== null) {
    configValue = configValueBasedOnThread;
  }
  return configValue;
};

// src/components/fhir-response-config-context/fhir-response-config-context.tsx
import React11, { createContext as createContext2, useState as useState3, useContext as useContext2 } from "react";
var FhirResponseConfigContext = createContext2([void 0, () => {
}]);
function FhirResponseConfigContextProvider({
  children
}) {
  const config = useState3(void 0);
  return /* @__PURE__ */ React11.createElement(FhirResponseConfigContext.Provider, { value: config }, children);
}
function useFhirResponseConfig() {
  const [value, setValue] = useContext2(FhirResponseConfigContext);
  const setConfig = React11.useCallback(
    (config) => {
      setValue(config);
    },
    [setValue]
  );
  return [value, setConfig];
}

// src/pages/components/message-header/message-header-contents.component.tsx
import React13 from "react";
import { useParamsLegacy as useParams2 } from "@leagueplatform/routing";
import {
  Flex as Flex8,
  HeadingThree as HeadingThree2,
  BodyTwo,
  SecondaryButton,
  Box as Box6,
  Caption,
  genesisStyled as genesisStyled4,
  css as css3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
import { EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";

// src/pages/components/mobile-menu/mobile-menu.component.tsx
import React12 from "react";
import {
  QuietButton,
  Flex as Flex7,
  VisuallyHidden as VisuallyHidden2,
  Image,
  genesisStyled as genesisStyled3,
  css as css2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
var StyledMenuButton = genesisStyled3(QuietButton)(
  ({ theme }) => css2({
    display: "none",
    "&:focus": {
      backgroundColor: "surface.background.primary"
    },
    "&:hover": {
      backgroundColor: "surface.background.primary"
    },
    [`@media screen and (max-width: ${theme.breakpoints.laptop})`]: {
      display: "block"
    }
  })
);
function MobileMenu({
  toggleMessageList,
  showMobileMessageList
}) {
  const { formatMessage } = useIntl9();
  const mobileMenuIcon2 = handleStaticAsset3(
    "MESSAGING_MOBILE_MENU_ICON" /* MESSAGING_MOBILE_MENU_ICON */
  );
  return /* @__PURE__ */ React12.createElement(
    StyledMenuButton,
    {
      onClick: () => toggleMessageList(!showMobileMessageList),
      paddingX: "half",
      paddingY: "half",
      type: "button",
      "aria-expanded": showMobileMessageList
    },
    /* @__PURE__ */ React12.createElement(Flex7, { justifyContent: "center", alignItems: "center" }, /* @__PURE__ */ React12.createElement(
      Image,
      {
        src: mobileMenuIcon2,
        alt: "",
        size: "oneAndHalf",
        "aria-hidden": "true"
      }
    )),
    /* @__PURE__ */ React12.createElement(VisuallyHidden2, null, formatMessage({ id: "TOGGLE_MENU" }))
  );
}

// src/pages/components/message-header/message-header-contents.component.tsx
var Banner = () => {
  const { formatMessage } = useIntl10();
  return /* @__PURE__ */ React13.createElement(
    Flex8,
    {
      alignItems: "center",
      borderBottomColor: "onSurface.border.subdued",
      borderBottomWidth: "thin",
      paddingX: "oneAndHalf",
      paddingY: "half"
    },
    /* @__PURE__ */ React13.createElement(Flex8, { marginInlineEnd: "threeQuarters", color: "onSurface.text.subdued" }),
    /* @__PURE__ */ React13.createElement(Caption, { color: "onSurface.text.subdued" }, formatMessage({ id: "ALL_MESSAGES_FOR_THREAD_BANNER" }))
  );
};
function MessageHeaderContents({
  setIsDetailsOpen,
  threadSubject,
  threadDescription,
  threadParticipants,
  isDraft,
  toggleMessageList,
  showMobileMessageList,
  threadInfoEnabled,
  messagingStyle = "bubble" /* BUBBLE */
}) {
  const { formatMessage } = useIntl10();
  const { data: messagingBannerEnabled } = useFeatureFlagQuery2(
    MESSAGING_BANNER_FLAG
  );
  const { threadId } = useParams2();
  const filteredParticipants = useRemoveCurrentUser(threadParticipants);
  const MessagesHeaderText = genesisStyled4(HeadingThree2)(
    ({ theme }) => css3({
      [`@media screen and (max-width: ${theme.breakpoints.phone})`]: {
        hyphens: "auto"
      }
    })
  );
  const userNames = getParticipantFirstNames(threadParticipants);
  const isBubbleStyle = messagingStyle === "bubble";
  const subject = isDraft ? formatMessage({ id: "NEW_MESSAGE" }) : threadSubject || userNames.join(", ");
  return /* @__PURE__ */ React13.createElement(
    Box6,
    {
      borderBottomColor: "onSurface.border.subdued",
      borderBottomWidth: "thin",
      borderStyle: "solid"
    },
    /* @__PURE__ */ React13.createElement(
      Flex8,
      {
        minWidth: "320px",
        alignItems: "center",
        backgroundColor: "surface.background.primary",
        paddingTop: "oneAndHalf",
        paddingBottom: "one",
        paddingX: { _: "half", phone: "twoAndHalf" }
      },
      /* @__PURE__ */ React13.createElement(
        MobileMenu,
        {
          toggleMessageList,
          showMobileMessageList
        }
      ),
      /* @__PURE__ */ React13.createElement(Flex8, { justifyContent: "space-between", width: "100%", alignItems: "center" }, /* @__PURE__ */ React13.createElement(Flex8, null, /* @__PURE__ */ React13.createElement(
        Box6,
        {
          display: { _: "none", tablet: "flex" },
          marginInlineStart: { tablet: "two", laptop: "0" }
        },
        isBubbleStyle && /* @__PURE__ */ React13.createElement(ParticipantsAvatar, { participants: filteredParticipants })
      ), /* @__PURE__ */ React13.createElement(Flex8, { flexDirection: "column", marginInlineStart: "one" }, /* @__PURE__ */ React13.createElement(MessagesHeaderText, { as: "h2" }, subject), threadInfoEnabled && /* @__PURE__ */ React13.createElement(BodyTwo, null, threadDescription))), threadId && threadInfoEnabled && /* @__PURE__ */ React13.createElement(
        SecondaryButton,
        {
          onClick: () => {
            trackMessagingAnalyticsEvent(EVENT_NAME4.BUTTON_CLICKED, {
              screen_name: "message thread" /* MESSAGE_THREAD */,
              detail: "thread details"
            });
            setIsDetailsOpen(true);
          },
          marginInlineStart: "one",
          borderRadius: "pill",
          paddingX: "oneAndHalf",
          paddingY: "half"
        },
        formatMessage({ id: "DETAILS" })
      ))
    ),
    messagingBannerEnabled && /* @__PURE__ */ React13.createElement(Banner, null)
  );
}

// src/pages/components/message-header/message-header.component.tsx
var ThreadMessageHeader = ({
  setIsDetailsOpen,
  toggleMessageList,
  showMobileMessageList,
  threadInfoEnabled: defaultThreadInfoEnabled
}) => {
  var _a;
  const { formatMessage } = useIntl11();
  const { threadId } = useParams3();
  const {
    data: threadData,
    isLoading,
    error: error2
  } = useMessageThreadDetails(threadId);
  const [, setPageError] = usePageError();
  const threadConfigs = (_a = threadData == null ? void 0 : threadData.meta) == null ? void 0 : _a.overrideConfigurations;
  const [configFromQuestionnaire] = useFhirResponseConfig();
  const { messagingStyle: defaultMessagingStyle } = useGetMessagingStyle();
  const threadInfoEnabled = React14.useMemo(
    () => getConfigOverride({
      defaultConfigValue: defaultThreadInfoEnabled,
      configName: "THREAD_INFO_ENABLED",
      fhirResponseConfigs: configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      threadConfigs,
      format: "bool"
    }),
    [configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data, defaultThreadInfoEnabled, threadConfigs]
  );
  const messagingStyle = React14.useMemo(
    () => getConfigOverride({
      defaultConfigValue: defaultMessagingStyle,
      configName: "MESSAGING_THREAD_UI_STYLE",
      fhirResponseConfigs: configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      threadConfigs,
      format: "string"
    }),
    [configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data, defaultMessagingStyle, threadConfigs]
  );
  if (isLoading) {
    return /* @__PURE__ */ React14.createElement(
      Flex9,
      {
        backgroundColor: "surface.background.primary",
        color: "decorative.brand.primary.default",
        justifyContent: "center",
        padding: "three",
        borderBottomColor: "onSurface.border.subdued",
        borderBottomWidth: "thin",
        borderStyle: "solid"
      },
      /* @__PURE__ */ React14.createElement(Spinner3, { isLoading: true })
    );
  }
  const isThreadDetailsError = error2 || !(threadData == null ? void 0 : threadData.data);
  if (isThreadDetailsError) {
    setPageError(isThreadDetailsError);
    const errorImage = handleStaticAsset4(
      "MESSAGING_ERROR" /* MESSAGING_ERROR */
    );
    return /* @__PURE__ */ React14.createElement(
      Flex9,
      {
        backgroundColor: "surface.background.primary",
        paddingX: "three",
        paddingY: "two",
        alignItems: "center",
        borderBottomColor: "onSurface.border.subdued",
        borderBottomWidth: "thin",
        borderStyle: "solid"
      },
      /* @__PURE__ */ React14.createElement(
        CoverImage2,
        {
          alt: "",
          marginInlineEnd: "oneAndHalf",
          src: errorImage,
          size: "three"
        }
      ),
      /* @__PURE__ */ React14.createElement(BodyOne4, null, formatMessage({ id: "GENERIC_MESSAGING_ERROR" }))
    );
  }
  return /* @__PURE__ */ React14.createElement(
    MessageHeaderContents,
    {
      setIsDetailsOpen,
      threadSubject: threadData.data.subject,
      threadDescription: threadData.data.description,
      threadParticipants: threadData.data.participants.data,
      toggleMessageList,
      showMobileMessageList,
      threadInfoEnabled,
      messagingStyle
    }
  );
};
var MessageHeader = ({
  setIsDetailsOpen,
  draftSubject,
  draftParticipants,
  toggleMessageList,
  showMobileMessageList
}) => {
  const { formatMessage } = useIntl11();
  const { threadId } = useParams3();
  const { data: messagingContactsData } = useMessagingContacts();
  const { threadInfoEnabled: defaultThreadInfoEnabled } = useGetThreadInfoConfig();
  const { messagingStyle: defaultMessagingStyle } = useGetMessagingStyle();
  const [configFromQuestionnaire] = useFhirResponseConfig();
  const draftThreadInfoEnabled = React14.useMemo(
    () => getConfigOverride({
      defaultConfigValue: defaultThreadInfoEnabled,
      configName: "THREAD_INFO_ENABLED",
      fhirResponseConfigs: configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      format: "bool"
    }),
    [configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data, defaultThreadInfoEnabled]
  );
  const draftMessagingStyle = React14.useMemo(
    () => getConfigOverride({
      defaultConfigValue: defaultMessagingStyle,
      configName: "MESSAGING_THREAD_UI_STYLE",
      fhirResponseConfigs: configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      format: "string"
    }),
    [configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data, defaultMessagingStyle]
  );
  if (threadId) {
    return /* @__PURE__ */ React14.createElement(
      ThreadMessageHeader,
      {
        setIsDetailsOpen,
        toggleMessageList,
        showMobileMessageList,
        threadInfoEnabled: defaultThreadInfoEnabled
      }
    );
  }
  const draftParticipantsList = draftParticipants.map(
    ({ id }) => messagingContactsData.byId[id]
  );
  return /* @__PURE__ */ React14.createElement(
    MessageHeaderContents,
    {
      setIsDetailsOpen,
      threadSubject: draftSubject,
      threadDescription: formatMessage({ id: "NEW_MESSAGE_DEFAULT" }),
      threadParticipants: draftParticipantsList,
      isDraft: true,
      toggleMessageList,
      showMobileMessageList,
      threadInfoEnabled: draftThreadInfoEnabled,
      messagingStyle: draftMessagingStyle
    }
  );
};

// src/pages/components/message-body-wrapper/message-body-wrapper.component.tsx
import React27, { useEffect as useEffect12 } from "react";
import { Box as Box17, Flex as Flex15 } from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME9 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams7 } from "@leagueplatform/routing";

// src/pages/components/compose-message-footer/compose-form.component.tsx
import React19 from "react";
import { KEY } from "@leagueplatform/web-common";
import { Formik, Form } from "formik";
import { Flex as Flex10, genesisStyled as genesisStyled6 } from "@leagueplatform/genesis-commons";

// src/hooks/use-post-new-thread.hook.ts
import { useMutation as useMutation2, useQueryClient as useQueryClient4 } from "@tanstack/react-query";
import { useNavigateLegacy as useNavigate2 } from "@leagueplatform/routing";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import {
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH6,
  postMessagingThread
} from "@leagueplatform/messaging-api";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
var usePostNewThread = () => {
  const { data: isQuestionnaireDisabled } = useFeatureFlagQuery3(
    DISABLE_MESSAGING_QUESTIONNAIRE
  );
  const navigate = useNavigate2();
  const queryClient = useQueryClient4();
  const searchParams = useSearchParams();
  const searchParam = searchParams.get("h") ? HOME_SEARCH_PARAM : "";
  return useMutation2(
    ({ newThreadData }) => postMessagingThread({ newThreadData, isQuestionnaireDisabled }),
    {
      onSuccess: (threadData, { resetForm, resetDraftState }) => {
        const { id: threadId } = threadData.data;
        queryClient.invalidateQueries([MESSAGING_THREADS_PATH6]);
        navigate(MESSAGING_LINKS.getMessagesForThread(threadId, searchParam));
        resetForm();
        resetDraftState();
      },
      onError: () => {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "UNABLE_TO_SEND"
        });
      }
    }
  );
};

// src/hooks/use-send-message-in-thread.hook.ts
import { useMutation as useMutation3, useQueryClient as useQueryClient5 } from "@tanstack/react-query";
import { useParamsLegacy as useParams4 } from "@leagueplatform/routing";
import { toastActions as toastActions2, TOAST_STATUS as TOAST_STATUS2 } from "@leagueplatform/toast-messages";
import {
  postCreateMessageInThread,
  THREAD_MESSAGES_PATH as THREAD_MESSAGES_PATH3,
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH8
} from "@leagueplatform/messaging-api";
import { deserialise } from "kitsu-core";
import { EVENT_NAME as EVENT_NAME5 } from "@leagueplatform/analytics";

// src/utils/update-local-cache/update-local-cache.util.ts
import {
  THREAD_MESSAGES_PATH as THREAD_MESSAGES_PATH2,
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH7
} from "@leagueplatform/messaging-api";
var updateLocalCache = (queryClient, deserialisedMessage, threadId) => {
  const previousMessageData = queryClient.getQueryData([THREAD_MESSAGES_PATH2, threadId]);
  if (previousMessageData == null ? void 0 : previousMessageData.pages.length) {
    const previousMessageDataCopy = JSON.parse(
      JSON.stringify(previousMessageData)
    );
    previousMessageDataCopy.pages[0].data.unshift(deserialisedMessage.data);
    queryClient.setQueryData(
      [THREAD_MESSAGES_PATH2, threadId],
      previousMessageDataCopy
    );
  }
  const previousThreadData = queryClient.getQueryData([MESSAGING_THREADS_PATH7]);
  if (previousThreadData == null ? void 0 : previousThreadData.pages.length) {
    const previousThreadDataCopy = JSON.parse(
      JSON.stringify(previousThreadData)
    );
    previousThreadDataCopy.pages.every((page, pageIndex) => {
      const threadIndex = page.data.findIndex(
        (thread) => thread.id === threadId
      );
      if (threadIndex !== -1) {
        const threadToUpdate = previousThreadDataCopy.pages[pageIndex].data[threadIndex];
        const updatedThread = __spreadProps(__spreadValues({}, threadToUpdate), {
          latestMessage: deserialisedMessage
        });
        previousThreadDataCopy.pages[pageIndex].data.splice(threadIndex, 1);
        previousThreadDataCopy.pages[0].data.unshift(updatedThread);
        queryClient.setQueryData(
          [MESSAGING_THREADS_PATH7],
          previousThreadDataCopy
        );
        return false;
      }
      return true;
    });
  }
};

// src/hooks/use-send-message-in-thread.hook.ts
var useSendMessageInThread = () => {
  var _a, _b;
  const { threadId } = useParams4();
  const queryClient = useQueryClient5();
  const { data: threadData, isInitialLoading: isLoadingThreadData } = useMessageThreadDetails(threadId);
  const threadContainsCareAdvisor = !!((_b = (_a = threadData == null ? void 0 : threadData.data) == null ? void 0 : _a.participants) == null ? void 0 : _b.data.some(
    ({ role }) => role === "care-advisor"
  ));
  return __spreadProps(__spreadValues({}, useMutation3(
    ({ newMessageData }) => postCreateMessageInThread(newMessageData, threadId),
    {
      onSuccess: (_data, { resetForm }) => {
        const deserialisedMessage = deserialise(_data);
        const hasDocument = !!deserialisedMessage.data.documents;
        updateLocalCache(queryClient, deserialisedMessage, threadId);
        trackMessagingAnalyticsEvent(EVENT_NAME5.BUTTON_CLICKED, {
          screen_name: "message thread" /* MESSAGE_THREAD */,
          detail: "send",
          thread_contains_care_advisor: threadContainsCareAdvisor,
          has_document: hasDocument
        });
        queryClient.invalidateQueries([THREAD_MESSAGES_PATH3, threadId]);
        queryClient.invalidateQueries([MESSAGING_THREADS_PATH8]);
        resetForm();
      },
      onError: () => {
        toastActions2.add({
          type: TOAST_STATUS2.ERROR,
          textId: "UNABLE_TO_SEND"
        });
      }
    }
  )), {
    isLoadingThreadData
  });
};

// src/pages/components/compose-message-footer/compose-message-footer.constants.ts
var FILE_UPLOAD_NAME = "uploadedFile";
var TEXT_AREA_NAME = "messageText";

// src/pages/components/compose-message-footer/compose-message-footer.component.tsx
import React17, {
  useState as useState4,
  useEffect as useEffect6,
  useMemo as useMemo2,
  useCallback as useCallback2,
  useRef as useRef2
} from "react";
import { useLocationLegacy as useLocation2 } from "@leagueplatform/routing";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { toastActions as toastActions3, TOAST_STATUS as TOAST_STATUS3 } from "@leagueplatform/toast-messages";
import {
  InputStatusMessage,
  Box as Box9,
  VisuallyHidden as VisuallyHidden3,
  UtilityText as UtilityText2,
  Button as Button2,
  styled as styled2,
  focusOutlineOuter,
  ParagraphText as ParagraphText2
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME6 } from "@leagueplatform/analytics";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
import { captureError } from "@leagueplatform/observability";

// src/utils/format-file-size.util.ts
var formatFileSize = (fileSize) => {
  const fileSizeKilobytes = Math.round(fileSize / 1e3);
  const fileSizeMegabytes = Math.round((fileSize / 1e3 / 1e3 + Number.EPSILON) * 10) / 10;
  let fileSizeDisplayed = `${fileSize} B`;
  if (fileSizeMegabytes >= 1) {
    fileSizeDisplayed = `${fileSizeMegabytes} MB`;
  } else if (fileSizeKilobytes >= 1) {
    fileSizeDisplayed = `${fileSizeKilobytes} KB`;
  }
  return fileSizeDisplayed;
};

// src/hooks/use-is-image-thumbnail.hook.ts
import { useCallback } from "react";

// src/messaging.config.ts
import { useConfigProperty } from "@leagueplatform/core";
var defaultConfig = {
  maxFileSize: 20971520,
  // 20 MB
  allowedFileTypes: "image/png, image/jpeg, image/heic, application/pdf, image/bmp, image/tiff, image/gif, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
  allowedFileTypesErrorList: ".ppt, .pptx, .doc, .docx, .xls, .xlsx, .csv, .pdf, .png, .jpeg, .jpg, .heic, .gif, .tiff, .tif, .bmp",
  allowedImageTypes: [
    "png",
    "image/png",
    "jpg",
    "image/jpg",
    "jpeg",
    "image/jpeg",
    "bmp",
    "image/bmp",
    "tiff",
    "image/tiff",
    "gif",
    "image/gif",
    "heic",
    "image/heic"
  ],
  messageInputCharacterLength: 1e4
};
var useMessagingConfig = () => useConfigProperty("messaging", defaultConfig);

// src/hooks/use-is-image-thumbnail.hook.ts
var useIsImageThumbnail = () => {
  const { allowedImageTypes } = useMessagingConfig();
  return useCallback(
    (file) => (
      // tiff and heic files are not well supported on browsers
      // for the purpose of this function we will return false for those two
      allowedImageTypes.includes(file.type) && !file.type.includes("tiff") && !file.type.includes("heic")
    ),
    [allowedImageTypes]
  );
};

// src/pages/components/compose-message-footer/compose-message-footer.component.tsx
import { ErrorState as ErrorState2 } from "@leagueplatform/web-common-components";

// src/hooks/use-get-compose-message-footer-config.hook.ts
var useGetComposeMessageFooterConfig = () => {
  var _a;
  const { data } = useGetMessagingConfig();
  const getAttributeByName = (attrName) => {
    var _a2, _b;
    const attrData = (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.find(
      (config) => {
        var _a3;
        return ((_a3 = config == null ? void 0 : config.attributes) == null ? void 0 : _a3.name) === attrName;
      }
    );
    return (_b = attrData == null ? void 0 : attrData.attributes) == null ? void 0 : _b.value;
  };
  const allowedFileTypes = (_a = getAttributeByName("DOC_TYPES")) != null ? _a : "";
  const maxFileSize = getAttributeByName("DOC_MAX_SIZE") ? Number(getAttributeByName("DOC_MAX_SIZE")) : void 0;
  const documentUploadEnabled = getAttributeByName("DOC_UPLOAD_ENABLED") === "true";
  const maxMessageLength = getAttributeByName("MESSAGE_MAX_SIZE") ? Number(getAttributeByName("MESSAGE_MAX_SIZE")) : void 0;
  const maxNumberOfDocs = getAttributeByName("MAX_NUMBER_OF_DOCS") ? Number(getAttributeByName("MAX_NUMBER_OF_DOCS")) : void 0;
  return {
    allowedFileTypes,
    maxFileSize,
    documentUploadEnabled,
    maxMessageLength,
    maxNumberOfDocs
  };
};

// src/pages/components/compose-message-footer/autoresize-textarea.component.tsx
import React15, { useEffect as useEffect5 } from "react";
import { Field } from "formik";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import {
  Textarea,
  genesisStyled as genesisStyled5,
  Box as Box7,
  css as css4
} from "@leagueplatform/genesis-commons";
var TEXTAREA_MAX_HEIGHT = 150;
var StyledTextareaWrapper = genesisStyled5(Box7)(
  () => css4({
    "& > .Genesis-TextInputBase-Container::before": {
      borderRadius: "extraLarge"
    }
  })
);
var useAutosizeTextArea = (textAreaRef, value) => {
  useEffect5(() => {
    if (textAreaRef) {
      textAreaRef.style.height = "0px";
      const { scrollHeight } = textAreaRef;
      textAreaRef.style.height = `${Math.min(
        scrollHeight + 2,
        TEXTAREA_MAX_HEIGHT
      )}px`;
    }
  }, [textAreaRef, value]);
};
var AutoResizeTextarea = ({
  id,
  textareaName,
  textValue,
  disabled,
  textAreaRef,
  validateTextarea,
  ariaDescribedby
}) => {
  const { formatMessage } = useIntl12();
  useAutosizeTextArea(textAreaRef.current, textValue);
  return /* @__PURE__ */ React15.createElement(Field, { name: textareaName, validate: validateTextarea }, ({ field }) => {
    const _a = field, { name } = _a, fieldVals = __objRest(_a, ["name"]);
    return /* @__PURE__ */ React15.createElement(StyledTextareaWrapper, null, /* @__PURE__ */ React15.createElement(
      Textarea,
      __spreadProps(__spreadValues({
        disabled,
        name
      }, fieldVals), {
        placeholder: formatMessage({ id: "WRITE_A_MESSAGE" }),
        id,
        rows: 1,
        paddingX: "half",
        paddingY: "half",
        minHeight: "twoAndHalf",
        backgroundColor: "surface.background.secondary",
        borderRadius: "extraLarge",
        borderColor: "transparent",
        hoverStyle: { borderColor: "transparent" },
        resize: "none",
        ref: textAreaRef,
        autoFocus: true,
        "aria-describedby": ariaDescribedby,
        className: "auto-resize-textarea"
      })
    ));
  });
};

// src/pages/components/compose-message-footer/file-preview.component.tsx
import React16, { memo } from "react";
import {
  styled,
  Button,
  ParagraphText,
  Box as Box8,
  UtilityText
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";
var StyledImage = styled("img", {
  borderColor: "$onSurfaceBorderSubdued",
  borderWidth: "$thin",
  borderStyle: "$solid",
  borderRadius: "$medium",
  width: "8rem",
  height: "8rem",
  objectFit: "cover"
});
var CloseButton = ({
  onClick,
  top,
  insetInlineEnd,
  insetInlineStart,
  filename,
  fileSize
}) => {
  const { formatMessage } = useIntl13();
  const closeIcon2 = handleStaticAsset5(
    "MESSAGING_CLOSE_ICON" /* MESSAGING_CLOSE_ICON */
  );
  return /* @__PURE__ */ React16.createElement(
    Button,
    {
      css: {
        position: "absolute",
        top,
        insetInlineEnd,
        insetInlineStart,
        backgroundColor: "$onSurfaceIconPrimary",
        borderColor: "$interactiveIconDefault",
        padding: "$quarter"
      },
      icon: closeIcon2,
      hideLabel: true,
      onClick,
      size: "small"
    },
    formatMessage({ id: "REMOVE_FILE_FILENAME" }, { filename, fileSize })
  );
};
var FilePreviewRaw = ({
  fileUpload,
  onRemove: handleRemoveFile
}) => {
  var _a;
  const { formatMessage } = useIntl13();
  const isImageThumbnail = useIsImageThumbnail();
  if (!fileUpload)
    return null;
  const { name, size } = fileUpload;
  const fileSizeDisplayed = formatFileSize(size);
  const fileTypeDisplayed = (_a = name.split(".").pop()) == null ? void 0 : _a.toUpperCase();
  if (isImageThumbnail(fileUpload)) {
    const imagePreview = URL.createObjectURL(fileUpload);
    return /* @__PURE__ */ React16.createElement(
      Box8,
      {
        css: {
          position: "relative",
          padding: "$half",
          marginTop: "$quarter"
        }
      },
      /* @__PURE__ */ React16.createElement(
        StyledImage,
        {
          src: imagePreview,
          alt: formatMessage({ id: "PREVIEW_OF_FILE" }, { fileName: name })
        }
      ),
      /* @__PURE__ */ React16.createElement(ParagraphText, { css: { position: "absolute" }, size: "sm" }, fileSizeDisplayed),
      /* @__PURE__ */ React16.createElement(
        CloseButton,
        {
          onClick: () => handleRemoveFile(fileUpload),
          top: "0",
          insetInlineEnd: "0",
          filename: name,
          fileSize: fileSizeDisplayed
        }
      )
    );
  }
  return /* @__PURE__ */ React16.createElement(
    Box8,
    {
      css: {
        position: "relative",
        padding: "$half",
        width: "25.4rem",
        "@mobile": {
          width: "100%"
        }
      }
    },
    /* @__PURE__ */ React16.createElement(
      Box8,
      {
        css: {
          backgroundColor: "$surfaceBackgroundPrimary",
          padding: "$threeQuarters",
          borderRadius: "$medium",
          display: "flex",
          alignItems: "center",
          "& svg": {
            flexShrink: 0
          },
          // we need to define a max-width for the document icon
          // tenants who do not use a react-svg component for this override
          // will see a extremely large img element
          // this a temp solution until we work on the following todo
          // TODO: remove this as part of: https://everlong.atlassian.net/browse/PCHAT-4214
          // once we can use the same react-svg components for all tenants, we should be able to remove this
          "& > img": {
            maxWidth: "24px"
          }
        }
      },
      handleStaticAsset5("MESSAGING_DOCUMENT_ICON" /* MESSAGING_DOCUMENT_ICON */, {
        isComponent: true
      }),
      /* @__PURE__ */ React16.createElement(
        Box8,
        {
          css: { marginInlineStart: "$half", maxWidth: "calc(100% - 3.2rem)" }
        },
        /* @__PURE__ */ React16.createElement(
          ParagraphText,
          {
            size: "sm",
            css: {
              "&&": {
                marginBlockEnd: "$none"
              },
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          },
          name
        ),
        /* @__PURE__ */ React16.createElement(
          ParagraphText,
          {
            size: "sm",
            css: {
              "&&": {
                marginBlockEnd: "$none"
              }
            }
          },
          fileTypeDisplayed,
          /* @__PURE__ */ React16.createElement(UtilityText, { size: "sm", "aria-hidden": "true" }, "\xA0\u2022"),
          /* @__PURE__ */ React16.createElement(UtilityText, { size: "sm" }, "\xA0", fileSizeDisplayed)
        )
      )
    ),
    /* @__PURE__ */ React16.createElement(
      CloseButton,
      {
        onClick: () => handleRemoveFile(fileUpload),
        top: "0",
        insetInlineEnd: "0",
        filename: name,
        fileSize: fileSizeDisplayed
      }
    )
  );
};
var FilePreview = memo(FilePreviewRaw);

// src/pages/components/compose-message-footer/compose-message-footer.component.tsx
var StyledLabel = styled2("label", {
  order: "1",
  borderRadius: "$circle",
  color: "$interactiveActionPrimary",
  paddingX: "$quarter",
  paddingY: "$quarter",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "$tertiaryBackgroundHovered",
    color: "$tertiaryTextHovered"
  },
  "&:active": {
    backgroundColor: "$tertiaryBackgroundPressed",
    color: "$tertiaryTextHovered"
  },
  "&:focus-within": __spreadValues({
    backgroundColor: "$tertiaryBackgroundHovered",
    color: "$tertiaryTextHovered"
  }, focusOutlineOuter)
});
var FILE_UPLOAD_ID = "uploadedFileId";
var TEXT_AREA_ID = "textAreaId";
var ANNOUNCEMENT_TIMEOUT_DURATION = 2e3;
var ComposeMessageFooter = ({
  values,
  setFieldValue,
  isLoading,
  isButtonDisabled,
  resetForm,
  textareaError,
  threadConfigOverride
}) => {
  const { formatMessage } = useIntl14();
  const { pathname } = useLocation2();
  const [currentLocation, setCurrentLocation] = useState4(pathname);
  const [isDragging, setIsDragging] = useState4(false);
  const [announcementText, setAnnouncementText] = useState4("");
  const { error: messagingConfigError, isError: messagingConfigIsError } = useGetMessagingConfig();
  const [configValue] = useFhirResponseConfig();
  const textAreaRef = React17.useRef(null);
  useEffect6(() => {
    var _a;
    if (currentLocation !== pathname) {
      resetForm();
      setCurrentLocation(pathname);
      (_a = textAreaRef.current) == null ? void 0 : _a.focus();
    }
  }, [currentLocation, setCurrentLocation, pathname, resetForm]);
  const {
    allowedFileTypes: defaultAllowedFileTypes,
    maxFileSize: defaultMaxFileSize,
    documentUploadEnabled: defaultDocumentUploadEnabled,
    maxMessageLength: defaultMaxMessageLength,
    maxNumberOfDocs: defaultMaxNumberOfDocs
  } = useGetComposeMessageFooterConfig();
  const allowedFileTypes = useMemo2(
    () => getConfigOverride({
      defaultConfigValue: defaultAllowedFileTypes,
      configName: "DOC_TYPES",
      fhirResponseConfigs: configValue == null ? void 0 : configValue.data,
      threadConfigs: threadConfigOverride,
      format: "string"
    }),
    [configValue == null ? void 0 : configValue.data, defaultAllowedFileTypes, threadConfigOverride]
  );
  const maxFileSize = useMemo2(
    () => getConfigOverride({
      defaultConfigValue: defaultMaxFileSize,
      configName: "DOC_MAX_SIZE",
      fhirResponseConfigs: configValue == null ? void 0 : configValue.data,
      threadConfigs: threadConfigOverride,
      format: "number"
    }),
    [configValue == null ? void 0 : configValue.data, defaultMaxFileSize, threadConfigOverride]
  );
  const documentEnabled = useMemo2(
    () => getConfigOverride({
      defaultConfigValue: defaultDocumentUploadEnabled,
      configName: "DOC_UPLOAD_ENABLED",
      fhirResponseConfigs: configValue == null ? void 0 : configValue.data,
      threadConfigs: threadConfigOverride,
      format: "bool"
    }),
    [configValue == null ? void 0 : configValue.data, defaultDocumentUploadEnabled, threadConfigOverride]
  );
  const maxMessageLength = useMemo2(
    () => getConfigOverride({
      defaultConfigValue: defaultMaxMessageLength,
      configName: "MESSAGE_MAX_SIZE",
      fhirResponseConfigs: configValue == null ? void 0 : configValue.data,
      threadConfigs: threadConfigOverride,
      format: "number"
    }),
    [configValue == null ? void 0 : configValue.data, defaultMaxMessageLength, threadConfigOverride]
  );
  const maxNumberOfDocs = useMemo2(
    () => getConfigOverride({
      defaultConfigValue: defaultMaxNumberOfDocs,
      configName: "MAX_NUMBER_OF_DOCS",
      fhirResponseConfigs: configValue == null ? void 0 : configValue.data,
      threadConfigs: threadConfigOverride,
      format: "number"
    }),
    [configValue == null ? void 0 : configValue.data, defaultMaxNumberOfDocs, threadConfigOverride]
  );
  useEffect6(() => {
    var _a;
    if (!isLoading) {
      (_a = textAreaRef.current) == null ? void 0 : _a.focus();
    }
  }, [isLoading]);
  useEffect6(() => {
    const handleDragEnter = () => setIsDragging(true);
    window.addEventListener("dragenter", handleDragEnter);
    return () => {
      window.removeEventListener("dragenter", handleDragEnter);
    };
  }, []);
  const filesArray = useMemo2(() => values[FILE_UPLOAD_NAME] || [], [values]);
  const isImageThumbnail = useIsImageThumbnail();
  const imageThumbnails = useMemo2(
    () => filesArray.filter((file) => isImageThumbnail(file)),
    [filesArray, isImageThumbnail]
  );
  const nonImageThumbnails = useMemo2(
    () => filesArray.filter((file) => !isImageThumbnail(file)),
    [filesArray, isImageThumbnail]
  );
  const validateAndSetFile = (file) => {
    var _a;
    const allowedFileTypesArray = allowedFileTypes.split(", ");
    if (filesArray.length >= maxNumberOfDocs) {
      const fileTooLargeError = new Error(
        "Document / surpasses max number of documents allowed"
      );
      captureError(fileTooLargeError);
      toastActions3.add({
        type: TOAST_STATUS3.ERROR,
        textId: "ATTACHMENT_LIMIT_REACHED",
        shouldAutoClose: false,
        // content is incorrectly typed requiring a key/value pair, but is functional with a string.
        // Eugen and I spoke about this and the web plat team will look into it, for now he said
        // it is ok to ts-ignore
        // @ts-ignore
        content: formatMessage(
          { id: "MAXIMUM_NUM_OF_ATTACHMENTS_ALLOWED" },
          { maxNumberOfDocs }
        )
      });
    } else if (file.size > maxFileSize) {
      const fileTooLargeError = new Error(
        "Document / photo file size is too big"
      );
      captureError(fileTooLargeError, {
        context: {
          "Response Info": {
            "File Size": `${file.size} bytes`,
            "Max Size": `${maxFileSize} bytes`
          }
        }
      });
      toastActions3.add({
        type: TOAST_STATUS3.ERROR,
        textId: "FILE_TOO_LARGE",
        shouldAutoClose: false,
        // content is incorrectly typed requiring a key/value pair, but is functional with a string.
        // Eugen and I spoke about this and the web plat team will look into it, for now he said
        // it is ok to ts-ignore
        // @ts-ignore
        content: formatMessage(
          { id: "FILE_SHOULD_BE_UNDER" },
          { fileSize: formatFileSize(maxFileSize) }
        )
      });
    } else if (!allowedFileTypesArray.includes(
      `.${(_a = file.name.split(".").pop()) == null ? void 0 : _a.toLowerCase()}`
    )) {
      const fileTypeNotSupportedError = new Error(
        "Document / photo file type is not supported"
      );
      captureError(fileTypeNotSupportedError, {
        context: {
          "Response Info": {
            "File Type": file.type,
            "File Name": file.name
          }
        }
      });
      toastActions3.add({
        type: TOAST_STATUS3.ERROR,
        textId: "OOPS_FILE_TYPE_ISNT_SUPPORTED",
        shouldAutoClose: false,
        // See comment on line 135
        // @ts-ignore
        content: formatMessage(
          { id: "ATTACHMENT_TYPES_ALLOWED" },
          { fileTypes: allowedFileTypes }
        )
      });
    } else {
      setFieldValue(FILE_UPLOAD_NAME, [...filesArray, file]);
      setAnnouncementText(`File selected ${file.name}`);
    }
  };
  const handleDrop = (e) => {
    var _a;
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (!((_a = e == null ? void 0 : e.dataTransfer) == null ? void 0 : _a.items.length))
      return;
    const file = e.dataTransfer.items[0].getAsFile();
    if (!file)
      return;
    validateAndSetFile(file);
  };
  const validateTextarea = (value) => {
    let error2;
    if (maxMessageLength && value.length > maxMessageLength) {
      error2 = formatMessage(
        {
          id: "CHAR_LIMIT_EXCEEDED"
        },
        { maximum: maxMessageLength }
      );
    }
    return error2;
  };
  const handleRemoveFile = useCallback2(
    (removedFile) => {
      const removedFileIndex = filesArray == null ? void 0 : filesArray.findIndex(
        (file) => file === removedFile
      );
      const filesArrayCopy = [...filesArray];
      filesArrayCopy.splice(removedFileIndex, 1);
      setFieldValue(FILE_UPLOAD_NAME, filesArrayCopy);
      const removalAnnouncement = formatMessage(
        { id: "MESSAGING_FILE_REMOVAL_ANNOUNCEMENT" },
        { fileName: removedFile.name }
      );
      setAnnouncementText(removalAnnouncement);
    },
    [filesArray, formatMessage, setFieldValue]
  );
  const clearAnnouncementTimeoutRef = useRef2();
  useEffect6(() => {
    if (clearAnnouncementTimeoutRef.current && announcementText) {
      clearTimeout(clearAnnouncementTimeoutRef.current);
      clearAnnouncementTimeoutRef.current = void 0;
    }
    if (announcementText) {
      clearAnnouncementTimeoutRef.current = setTimeout(() => {
        setAnnouncementText("");
      }, ANNOUNCEMENT_TIMEOUT_DURATION);
      return () => {
        if (clearAnnouncementTimeoutRef.current) {
          clearTimeout(clearAnnouncementTimeoutRef.current);
          clearAnnouncementTimeoutRef.current = void 0;
        }
      };
    }
    return void 0;
  }, [announcementText]);
  if (messagingConfigIsError) {
    /* @__PURE__ */ React17.createElement(ErrorState2, { error: messagingConfigError });
  }
  return /* @__PURE__ */ React17.createElement(
    Box9,
    {
      css: {
        paddingX: "$twoAndHalf",
        paddingY: "$two",
        marginBottom: "$quarter",
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        "@mobileLandscape": {
          paddingX: "$half"
        },
        "@mobile": {
          paddingX: "$half"
        }
      }
    },
    /* @__PURE__ */ React17.createElement(
      Box9,
      {
        onDrop: handleDrop,
        onDragOver: (e) => e.preventDefault(),
        onDragLeave: () => setIsDragging(false),
        css: {
          position: "fixed",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: 0,
          bottom: 0,
          pointerEvents: isDragging ? "auto" : "none",
          backgroundColor: isDragging ? "$interactiveBackgroundDefault" : "transparent",
          opacity: 0.5,
          zIndex: 1
        }
      }
    ),
    /* @__PURE__ */ React17.createElement(
      Box9,
      {
        css: {
          order: "2",
          flexGrow: "1",
          // a fixed width is required to avoid some unwanted stacking with
          // the upload button and textarea
          // it will not reflect the actual rendered width, as flexGrow will
          // allow the textarea to fill the remaining space
          width: "100px",
          paddingX: "$half",
          position: "relative"
        }
      },
      /* @__PURE__ */ React17.createElement(VisuallyHidden3, null, /* @__PURE__ */ React17.createElement("label", { htmlFor: TEXT_AREA_ID }, formatMessage({ id: "WRITE_A_MESSAGE" }))),
      /* @__PURE__ */ React17.createElement(
        Box9,
        {
          css: {
            backgroundColor: "$surfaceBackgroundSecondary",
            borderRadius: "$extraLarge"
          }
        },
        /* @__PURE__ */ React17.createElement(
          AutoResizeTextarea,
          {
            id: TEXT_AREA_ID,
            textareaName: TEXT_AREA_NAME,
            textValue: values[TEXT_AREA_NAME],
            disabled: isLoading,
            textAreaRef,
            validateTextarea,
            ariaDescribedby: textareaError ? `${TEXT_AREA_ID}-error` : void 0
          }
        ),
        filesArray.length > 0 && /* @__PURE__ */ React17.createElement(
          Box9,
          {
            css: {
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-end",
              paddingBottom: "$one"
            }
          },
          imageThumbnails.length > 0 && /* @__PURE__ */ React17.createElement(
            Box9,
            {
              css: {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-end",
                "@mobile": {
                  width: "100%"
                }
              }
            },
            imageThumbnails.map((file) => /* @__PURE__ */ React17.createElement(
              FilePreview,
              {
                key: file.lastModified,
                fileUpload: file,
                onRemove: handleRemoveFile
              }
            ))
          ),
          nonImageThumbnails.length > 0 && /* @__PURE__ */ React17.createElement(
            Box9,
            {
              css: {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-end",
                marginTop: imageThumbnails.length > 0 ? "$half" : void 0,
                "@mobile": {
                  width: "100%"
                }
              }
            },
            nonImageThumbnails.map((file) => /* @__PURE__ */ React17.createElement(
              FilePreview,
              {
                key: file.lastModified,
                fileUpload: file,
                onRemove: handleRemoveFile
              }
            ))
          )
        ),
        /* @__PURE__ */ React17.createElement(VisuallyHidden3, { as: "div", className: "announcement-text" }, announcementText && /* @__PURE__ */ React17.createElement(ParagraphText2, null, announcementText))
      ),
      textareaError && /* @__PURE__ */ React17.createElement(Box9, { css: { position: "absolute" } }, /* @__PURE__ */ React17.createElement(
        InputStatusMessage,
        {
          id: `${TEXT_AREA_ID}-error`,
          inputStatus: "error",
          statusIconLabel: formatMessage({ id: "ERROR" })
        },
        textareaError
      ))
    ),
    documentEnabled && /* @__PURE__ */ React17.createElement(StyledLabel, { htmlFor: FILE_UPLOAD_ID }, /* @__PURE__ */ React17.createElement(
      Box9,
      {
        css: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "$button"
        },
        "aria-hidden": "true"
      },
      handleStaticAsset6(
        "MESSAGING_ADD_DOCUMENT_ICON" /* MESSAGING_ADD_DOCUMENT_ICON */,
        {
          isComponent: true
        }
      )
    ), /* @__PURE__ */ React17.createElement(VisuallyHidden3, null, formatMessage({ id: "UPLOAD_MULTIPLE_FILES" }), /* @__PURE__ */ React17.createElement(
      "input",
      {
        id: FILE_UPLOAD_ID,
        name: FILE_UPLOAD_NAME,
        onChange: (e) => {
          var _a;
          if (!((_a = e.currentTarget.files) == null ? void 0 : _a.length)) {
            const fileUploadError = new Error(
              "Document / Photo upload error"
            );
            captureError(fileUploadError);
            return;
          }
          const file = e.currentTarget.files[0];
          validateAndSetFile(file);
        },
        type: "file",
        accept: allowedFileTypes,
        onClick: (e) => {
          trackMessagingAnalyticsEvent(EVENT_NAME6.BUTTON_CLICKED, {
            screen_name: "message thread" /* MESSAGE_THREAD */,
            detail: "document"
          });
          e.target.value = "";
        }
      }
    ))),
    /* @__PURE__ */ React17.createElement(
      Button2,
      {
        type: "submit",
        disabled: isButtonDisabled,
        loading: isLoading,
        hideLabel: isLoading,
        css: {
          order: 3,
          paddingX: "$oneAndHalf",
          paddingY: "$half",
          marginBottom: "$quarter",
          marginTop: "$one",
          flexBasis: "auto",
          justifyContent: "center",
          "@mobileLandscape": {
            flexBasis: "100%",
            marginTop: "$oneAndHalf"
          },
          "@mobile": {
            flexBasis: "100%",
            marginTop: "$oneAndHalf"
          }
        }
      },
      /* @__PURE__ */ React17.createElement(VisuallyHidden3, null, formatMessage({ id: "SEND_MESSAGE" })),
      /* @__PURE__ */ React17.createElement(
        UtilityText2,
        {
          css: { color: "inherit", fontWeight: "inherit" },
          "aria-hidden": "true"
        },
        formatMessage({ id: "SEND" })
      )
    )
  );
};

// src/pages/components/message-closed-text/message-closed-text.component.tsx
import React18 from "react";
import { Box as Box10, HeadingText } from "@leagueplatform/genesis-core";
import { useIntl as useIntl15 } from "react-intl";
var MessageClosedText = () => {
  const { formatMessage } = useIntl15();
  return /* @__PURE__ */ React18.createElement(Box10, null, /* @__PURE__ */ React18.createElement(
    HeadingText,
    {
      size: "md",
      level: "5",
      css: { padding: "$oneAndHalf", textAlign: "center" }
    },
    formatMessage({ id: "MESSAGE_CLOSED_TEXT" })
  ));
};

// src/pages/components/compose-message-footer/compose-form.component.tsx
var StyledForm = genesisStyled6(Form)`
  display: flex;
  flex-direction: column;
`;
var initialValues = {
  [TEXT_AREA_NAME]: "",
  [FILE_UPLOAD_NAME]: null
};
var ComposeForm = ({
  isDraftThread,
  draftThread,
  resetDraftState,
  messageClosed,
  threadConfigOverride
}) => {
  const { mutate: createThreadMutation, isLoading: isLoadingCreateThread } = usePostNewThread();
  const {
    mutate: createNewMessageMutation,
    isLoading: isLoadingNewMessage,
    isLoadingThreadData
  } = useSendMessageInThread();
  if (messageClosed) {
    return /* @__PURE__ */ React19.createElement(MessageClosedText, null);
  }
  return /* @__PURE__ */ React19.createElement(
    Formik,
    {
      initialValues,
      onSubmit: (values, { resetForm }) => {
        if (isDraftThread) {
          const newThreadData = {
            subject: draftThread.subject,
            participants: draftThread.participants,
            text: values[TEXT_AREA_NAME],
            document: values[FILE_UPLOAD_NAME],
            answers: draftThread.answers
          };
          createThreadMutation({
            newThreadData,
            resetForm,
            resetDraftState
          });
          return;
        }
        const newMessageData = {
          text: values[TEXT_AREA_NAME],
          document: values[FILE_UPLOAD_NAME]
        };
        createNewMessageMutation({
          newMessageData,
          resetForm
        });
      }
    },
    ({ values, setFieldValue, resetForm, submitForm, errors }) => {
      const isMessageDataLoading = isLoadingCreateThread || isLoadingNewMessage;
      const isFormEmpty = !values[TEXT_AREA_NAME].trimEnd().length && (!values[FILE_UPLOAD_NAME] || values[FILE_UPLOAD_NAME].length === 0);
      const isButtonDisabled = isLoadingThreadData || isFormEmpty;
      return /* @__PURE__ */ React19.createElement(
        StyledForm,
        {
          "data-testid": "compose-message-form",
          onKeyDown: (e) => {
            const activeElement = e.target;
            if (e.key === KEY.ENTER && !e.shiftKey && // Ensures we're not preventing the default behaviour of elements that should be triggered by the Enter key
            // such as the CloseButton in the FilePreview content,
            // and theSend button in the ComposeMessageFooter to behave as expected for keyboard users
            activeElement.tagName === "TEXTAREA") {
              e.preventDefault();
              if (!isFormEmpty) {
                submitForm();
              }
            }
          }
        },
        /* @__PURE__ */ React19.createElement(Flex10, { flexDirection: "column" }, /* @__PURE__ */ React19.createElement(
          ComposeMessageFooter,
          {
            values,
            setFieldValue,
            isLoading: isMessageDataLoading,
            isButtonDisabled,
            resetForm,
            textareaError: errors[TEXT_AREA_NAME],
            threadConfigOverride
          }
        ))
      );
    }
  );
};

// src/pages/components/message-body/message-body.component.tsx
import React26 from "react";
import { Box as Box16, Spinner as Spinner4, Flex as Flex14 } from "@leagueplatform/genesis-commons";
import { ErrorState as ErrorState3 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
import { useIntl as useIntl20 } from "@leagueplatform/locales";

// src/pages/components/messages-grid/messages-grid.component.tsx
import React25, { useEffect as useEffect11, useMemo as useMemo4, useState as useState5 } from "react";
import {
  Box as Box15,
  Flex as Flex13,
  BodyOneSecondary,
  SecondaryButton as SecondaryButton2
} from "@leagueplatform/genesis-commons";
import { Icon } from "@leagueplatform/genesis-core";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME8 } from "@leagueplatform/analytics";

// src/pages/utils/get-timebar-display-value.util.ts
import { isToday as isToday2 } from "date-fns";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
var getTimeBarDisplayValue = (formatMessage, formatDate, timestamp) => {
  const convertedTimestamp = new Date(timestamp);
  if (isToday2(convertedTimestamp)) {
    return formatMessage({ id: "TODAY" });
  }
  return formatDate(timestamp, SHORT_DATE_FORMAT);
};

// src/pages/utils/get-timebar-details.util.ts
var getTimeBarDetails = (formatMessage, formatDate, currentTimestamp, pastTimestamp, upcomingTimestamp) => {
  const currentFormattedTimestamp = getTimeBarDisplayValue(
    formatMessage,
    formatDate,
    currentTimestamp
  );
  let lastFormattedTimestamp;
  let upcomingFormattedTimestamp;
  if (pastTimestamp) {
    lastFormattedTimestamp = getTimeBarDisplayValue(
      formatMessage,
      formatDate,
      pastTimestamp
    );
  }
  if (upcomingTimestamp) {
    upcomingFormattedTimestamp = getTimeBarDisplayValue(
      formatMessage,
      formatDate,
      upcomingTimestamp
    );
  }
  const displayTimeBar = currentFormattedTimestamp !== lastFormattedTimestamp;
  const isDifferentDateIncoming = currentFormattedTimestamp !== upcomingFormattedTimestamp;
  return { displayTimeBar, isDifferentDateIncoming, currentFormattedTimestamp };
};

// src/pages/utils/get-message-props.util.tsx
var getMessageProps = ({
  normalizedParticipants,
  individualMessageDetails,
  individualMessageIndex,
  formatMessage,
  formatDate,
  threadMessages
}) => {
  var _a, _b, _c, _d;
  const sender = normalizedParticipants.byId[individualMessageDetails.sender.data.id];
  const previousMessageSenderId = (_a = threadMessages[individualMessageIndex - 1]) == null ? void 0 : _a.sender.data.id;
  const nextMessageSenderId = (_b = threadMessages[individualMessageIndex + 1]) == null ? void 0 : _b.sender.data.id;
  const { displayTimeBar, isDifferentDateIncoming, currentFormattedTimestamp } = getTimeBarDetails(
    formatMessage,
    formatDate,
    individualMessageDetails.sentAt,
    (_c = threadMessages[individualMessageIndex - 1]) == null ? void 0 : _c.sentAt,
    (_d = threadMessages[individualMessageIndex + 1]) == null ? void 0 : _d.sentAt
  );
  return {
    sender,
    previousMessageSenderId,
    nextMessageSenderId,
    displayTimeBar,
    isDifferentDateIncoming,
    currentFormattedTimestamp
  };
};

// src/pages/components/messages-grid/use-setup-grid-navigation.hook.ts
var useSetupGridNavigation = ({
  canFetchMessages,
  totalMessages,
  fetchNextPage
}) => {
  const { gridRef, currentGridCell } = useGridNavigation(
    {
      totalRows: totalMessages,
      totalCols: 1
    },
    {
      fetchNextPage,
      paginationDirection: "up" /* UP */,
      canFetchMessages
    },
    {
      row: totalMessages - 1,
      col: 0
    }
  );
  return { gridRef, currentGridCell };
};

// src/hooks/use-patch-thread-is-read-mutation.hook.ts
import { useParamsLegacy as useParams5 } from "@leagueplatform/routing";
import { useMutation as useMutation4, useQueryClient as useQueryClient6 } from "@tanstack/react-query";
import {
  patchThreadIsRead,
  MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH9
} from "@leagueplatform/messaging-api";
var usePatchThreadIsReadMutation = () => {
  const { threadId } = useParams5();
  const queryClient = useQueryClient6();
  return useMutation4(() => patchThreadIsRead(threadId), {
    onSuccess: () => {
      queryClient.invalidateQueries([MESSAGING_THREADS_PATH9]);
    },
    onError: () => {
    }
  });
};

// src/pages/components/messages-grid/use-mark-thread-as-read.hook.ts
import { useEffect as useEffect7 } from "react";
var useMarkThreadAsRead = ({
  threadDetails
}) => {
  const { mutate: markThreadAsRead } = usePatchThreadIsReadMutation();
  const {
    isRead,
    subject,
    participants: { data: participantsData }
  } = threadDetails;
  useEffect7(() => {
    if (!isRead) {
      markThreadAsRead();
    }
  }, [markThreadAsRead, isRead]);
  return { markThreadAsRead, subject, participantsData };
};

// src/pages/components/messages-grid/use-scroll-event-pagination.hook.ts
import { useEffect as useEffect8 } from "react";
var useScrollEventPagination = ({
  gridRef,
  canFetchMessages,
  fetchOnScroll: fetchOnScroll3,
  fetchNextPage
}) => {
  useEffect8(() => {
    var _a;
    const currentGridElement = (_a = gridRef.current) != null ? _a : document.body;
    const scrollListener = () => {
      if (canFetchMessages) {
        fetchOnScroll3(currentGridElement, fetchNextPage);
      }
    };
    currentGridElement.addEventListener("scroll", scrollListener);
    return () => currentGridElement.removeEventListener("scroll", scrollListener);
  });
};

// src/pages/components/messages-grid/use-grid-label.hook.ts
import { useIntl as useIntl16 } from "@leagueplatform/locales";
var useGridLabel = ({
  participantsData,
  subject
}) => {
  const { formatMessage } = useIntl16();
  const userNames = getParticipantFirstNames(participantsData);
  const gridLabel = subject ? formatMessage({ id: "MESSAGES_IN_CONVERSATION_TITLED" }, { subject }) : formatMessage(
    { id: "MESSAGES_IN_CONVERSATION_TITLED" },
    { participants: userNames.join(", ") }
  );
  return { gridLabel };
};

// src/pages/components/messages-grid/use-messages-grid.hook.ts
var fetchOnScroll2 = (scrollableElement, fetchNextPage) => {
  const { scrollTop } = scrollableElement;
  if (scrollTop === 0) {
    fetchNextPage();
  }
};
var useMessagesGrid = ({
  threadMessages,
  threadDetails,
  fetchNextPage,
  isFetchingNextPage,
  isPaginationError
}) => {
  const totalMessages = (threadMessages == null ? void 0 : threadMessages.length) || 0;
  const canFetchMessages = !isFetchingNextPage && !isPaginationError;
  const { gridRef, currentGridCell } = useSetupGridNavigation({
    canFetchMessages,
    totalMessages,
    fetchNextPage
  });
  const { markThreadAsRead, subject, participantsData } = useMarkThreadAsRead({
    threadDetails
  });
  useScrollEventPagination({
    gridRef,
    canFetchMessages,
    fetchOnScroll: fetchOnScroll2,
    fetchNextPage
  });
  const { gridLabel } = useGridLabel({ participantsData, subject });
  return {
    currentGridCell,
    gridLabel,
    gridRef,
    markThreadAsRead
  };
};

// src/pages/components/message/message.component.tsx
import React24 from "react";
import { Box as Box14, LabelText, Flex as Flex12 } from "@leagueplatform/genesis-commons";
import { Avatar as Avatar3 } from "@leagueplatform/web-common-components";

// src/pages/components/message/message-bubble.component.tsx
import React22, { useEffect as useEffect9 } from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import { SHORT_DATE_AND_TIME_FORMAT } from "@leagueplatform/web-common";
import { Tooltip } from "@leagueplatform/genesis-core";
import {
  Box as Box12,
  BodyOne as BodyOne5,
  VisuallyHidden as VisuallyHidden4,
  genesisStyled as genesisStyled8,
  Flex as Flex11,
  css as css6
} from "@leagueplatform/genesis-commons";

// src/pages/components/message/message-document.component.tsx
import React20, { useMemo as useMemo3 } from "react";
import {
  genesisStyled as genesisStyled7,
  css as css5,
  PrimaryButton as PrimaryButton2
} from "@leagueplatform/genesis-commons";
import { UtilityText as UtilityText3, Box as Box11 } from "@leagueplatform/genesis-core";
import {
  getAuthenticatedDocument
} from "@leagueplatform/messaging-api";
import { EVENT_NAME as EVENT_NAME7 } from "@leagueplatform/analytics";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";
import { toastActions as toastActions4, TOAST_STATUS as TOAST_STATUS4 } from "@leagueplatform/toast-messages";

// src/utils/download-document/download-document.util.ts
var downloadDocument = (blob, fileName, fileType) => {
  const objectURL = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectURL;
  link.setAttribute("target", "_blank");
  link.setAttribute("download", `${fileName}.${fileType.toLowerCase()}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// src/pages/components/message/message-document.component.tsx
var StyledLink = genesisStyled7(PrimaryButton2)(
  ({ fromCurrentUser, withBoxedStyling }) => css5(__spreadValues(__spreadProps(__spreadValues({
    padding: withBoxedStyling ? "threeQuarters" : "quarter",
    textDecoration: "underline",
    textAlign: "start",
    justifyContent: "flex-start",
    backgroundColor: "inherit",
    color: "inherit",
    width: "23rem",
    "& svg": {
      flexShrink: 0
    },
    // we need to define a max-width for the document icon
    // tenants who do not use a react-svg component for this override
    // will see a extremely large img element
    // this a temp solution until we work on the following todo
    // TODO: remove this as part of: https://everlong.atlassian.net/browse/PCHAT-4214
    // once we can use the same react-svg components for all tenants, we should be able to remove this
    "& > img": {
      maxWidth: "24px"
    }
  }, withBoxedStyling && {
    borderStyle: "solid",
    borderWidth: "thin",
    borderRadius: "extraLarge",
    borderColor: "onSurface.border.subdued"
  }), {
    "> span > span": {
      display: "flex",
      alignItems: "center"
    },
    "&:focus, &:hover": __spreadValues({
      backgroundColor: "transparent"
    }, withBoxedStyling && {
      borderColor: "onSurface.border.subdued"
    })
  }), fromCurrentUser && {
    "&:focus::before": __spreadValues({}, !withBoxedStyling && {
      color: "onSurface.border.subdued",
      boxShadow: "0 0 0 2px"
    })
  }))
);
var MessageDocument = ({
  document: document2,
  hasFocus,
  color,
  fromCurrentUser,
  onFocus,
  onBlur,
  withBoxedStyling
}) => {
  var _a;
  const { allowedImageTypes } = useMessagingConfig();
  const fileType = document2 == null ? void 0 : document2.fileType;
  const fileSize = formatFileSize((document2 == null ? void 0 : document2.fileSize) || 0);
  const documentAnalyticsDetail = useMemo3(() => {
    if (fileType) {
      const isImage = allowedImageTypes.includes(fileType);
      if (isImage) {
        return "image";
      }
    }
    return "file";
  }, [fileType, allowedImageTypes]);
  if (!document2)
    return null;
  const handleDocument = (downloadUrl, fileName, documentFileType = "") => __async(void 0, null, function* () {
    const documentDownloadResponse = yield getAuthenticatedDocument(
      downloadUrl
    );
    if (documentDownloadResponse.error) {
      toastActions4.add({
        type: TOAST_STATUS4.ERROR,
        textId: "UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG"
      });
    }
    if (documentDownloadResponse.data) {
      const documentDownloadBlob = yield documentDownloadResponse.data.blob();
      downloadDocument(documentDownloadBlob, fileName, documentFileType);
    }
  });
  return /* @__PURE__ */ React20.createElement(
    StyledLink,
    {
      tabIndex: hasFocus ? 0 : -1,
      color,
      onClick: () => {
        handleDocument(
          document2.downloadUrl,
          document2.fileName,
          document2.fileType
        );
        trackMessagingAnalyticsEvent(EVENT_NAME7.BUTTON_CLICKED, {
          screen_name: "message thread" /* MESSAGE_THREAD */,
          detail: documentAnalyticsDetail
        });
      },
      fromCurrentUser,
      withBoxedStyling,
      onFocus,
      onBlur
    },
    handleStaticAsset7("MESSAGING_DOCUMENT_ICON" /* MESSAGING_DOCUMENT_ICON */, {
      isComponent: true
    }),
    /* @__PURE__ */ React20.createElement(
      Box11,
      {
        css: {
          maxWidth: "17.4rem",
          marginInlineStart: "$half"
        }
      },
      /* @__PURE__ */ React20.createElement(
        UtilityText3,
        {
          css: {
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "inherit"
          }
        },
        `${document2.fileName}.${document2.fileType}`
      ),
      /* @__PURE__ */ React20.createElement(UtilityText3, { css: { display: "block", color: "inherit" } }, (_a = document2.fileType) == null ? void 0 : _a.toUpperCase(), !!(document2 == null ? void 0 : document2.fileSize) && /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(
        UtilityText3,
        {
          "aria-hidden": "true",
          css: {
            color: "inherit"
          }
        },
        "\xA0\u2022"
      ), /* @__PURE__ */ React20.createElement(
        UtilityText3,
        {
          css: {
            color: "inherit"
          }
        },
        "\xA0",
        fileSize
      )))
    )
  );
};

// src/pages/components/message/message-text-with-inline-links.component.tsx
import React21 from "react";
import linkifyHtml from "linkify-html";
import { HtmlToReact } from "@leagueplatform/web-common";
import { styled as styled3 } from "@leagueplatform/genesis-core";
var StyledLink2 = styled3("a", {
  color: "inherit",
  textDecoration: "underline"
});
var StyledLinkFromCurrentUser = styled3("a", {
  color: "inherit",
  textDecoration: "underline",
  '&[class*="GDS"]:focus': {
    outlineColor: "inherit"
  }
});
var MessageTextWithInlineLinks = ({
  fromCurrentUser,
  text
}) => {
  const linkifyOptions = {
    defaultProtocol: "https",
    attributes: {
      rel: "noopener noreferrer"
    }
  };
  const RichTextOptions = {
    a: {
      component: fromCurrentUser ? StyledLinkFromCurrentUser : StyledLink2,
      props: {
        target: "_blank"
      }
    }
  };
  return /* @__PURE__ */ React21.createElement(
    HtmlToReact,
    {
      htmlString: linkifyHtml(text, linkifyOptions),
      options: RichTextOptions
    }
  );
};

// src/pages/components/message/message-bubble.component.tsx
var StyledContainer = genesisStyled8(Flex11)(
  ({ displayFocusBorder }) => css6({
    borderColor: "transparent",
    borderRadius: "small",
    borderStyle: "solid",
    borderWidth: "thin",
    paddingY: "quarter",
    "&:hover": {
      backgroundColor: "highlight.background.subdued"
    },
    "&:focus-within": {
      backgroundColor: "highlight.background.subdued",
      borderColor: displayFocusBorder ? "interactive.focus.outer" : "transparent"
    }
  })
);
var StyledTextWrapper = genesisStyled8(BodyOne5)`
  word-break: break-word;
`;
var MessageBubble = ({
  backgroundColor,
  color,
  fromCurrentUser,
  hasFocus,
  messageDetails,
  sender,
  gridRef
}) => {
  const { formatDate, formatMessage } = useIntl17();
  const [displayFocusBorder, setDisplayFocusBorder] = React22.useState(true);
  const cellRef = React22.useRef(null);
  const { text, sentAt, documents } = messageDetails;
  useEffect9(() => {
    var _a, _b;
    const isFocusWithinGrid = (_a = gridRef.current) == null ? void 0 : _a.contains(document.activeElement);
    if (hasFocus && isFocusWithinGrid) {
      (_b = cellRef.current) == null ? void 0 : _b.focus();
    }
  }, [hasFocus, gridRef]);
  const messageDocuments = documents == null ? void 0 : documents.data;
  const user = fromCurrentUser ? formatMessage({ id: "YOU" }) : sender == null ? void 0 : sender.firstName;
  const formattedDate = formatDate(sentAt, SHORT_DATE_AND_TIME_FORMAT);
  return /* @__PURE__ */ React22.createElement(StyledContainer, { width: "100%", displayFocusBorder }, /* @__PURE__ */ React22.createElement(Tooltip, { align: "end", side: "bottom", content: formattedDate }, /* @__PURE__ */ React22.createElement(
    Flex11,
    {
      role: "gridcell",
      justifyContent: fromCurrentUser ? "flex-end" : "flex-start",
      width: "100%"
    },
    /* @__PURE__ */ React22.createElement(
      Box12,
      {
        backgroundColor,
        borderRadius: "extraLarge",
        padding: "threeQuarters",
        width: "fit-content",
        maxWidth: { _: "75%", phone: "50%" },
        tabIndex: hasFocus ? 0 : -1,
        ref: cellRef,
        focusStyle: { outline: "none", boxShadow: "none" }
      },
      /* @__PURE__ */ React22.createElement(StyledTextWrapper, { as: "span", color }, /* @__PURE__ */ React22.createElement(VisuallyHidden4, null, formatMessage({ id: "USER_COLON" }, { user })), text && /* @__PURE__ */ React22.createElement(
        MessageTextWithInlineLinks,
        {
          text,
          fromCurrentUser
        }
      ), messageDocuments == null ? void 0 : messageDocuments.map((document2) => /* @__PURE__ */ React22.createElement(React22.Fragment, { key: document2.downloadUrl }, /* @__PURE__ */ React22.createElement(VisuallyHidden4, null, formatMessage({ id: "WITH_DOCUMENT" })), /* @__PURE__ */ React22.createElement(Box12, { marginTop: "quarter" }, /* @__PURE__ */ React22.createElement(
        MessageDocument,
        {
          document: document2,
          hasFocus,
          color,
          fromCurrentUser,
          onFocus: () => setDisplayFocusBorder(false),
          onBlur: () => setDisplayFocusBorder(true)
        }
      )))), /* @__PURE__ */ React22.createElement(VisuallyHidden4, null, formattedDate))
    )
  )));
};

// src/pages/components/message/message-boxed.component.tsx
import React23, { useEffect as useEffect10 } from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { SHORT_DATE_AND_TIME_FORMAT_NO_TIMEZONE } from "@leagueplatform/web-common";
import { VisuallyHidden as VisuallyHidden5 } from "@leagueplatform/genesis-commons";
import {
  Box as Box13,
  UtilityText as UtilityText4,
  ParagraphText as ParagraphText3,
  Divider,
  styled as styled4
} from "@leagueplatform/genesis-core";
import { Avatar as Avatar2 } from "@leagueplatform/web-common-components";
var StyledTextWrapper2 = styled4("span", {
  wordBreak: "break-word"
});
var MessageBoxed = ({
  fromCurrentUser,
  hasFocus,
  messageDetails,
  gridRef,
  photoUrl,
  initials,
  senderName
}) => {
  const { formatDate, formatMessage } = useIntl18();
  const [displayFocusBorder, setDisplayFocusBorder] = React23.useState(true);
  const cellRef = React23.useRef(null);
  const { text, sentAt, documents } = messageDetails;
  useEffect10(() => {
    var _a, _b;
    const isFocusWithinGrid = (_a = gridRef.current) == null ? void 0 : _a.contains(document.activeElement);
    if (hasFocus && isFocusWithinGrid) {
      (_b = cellRef.current) == null ? void 0 : _b.focus();
    }
  }, [hasFocus, gridRef]);
  const messageDocuments = documents == null ? void 0 : documents.data;
  const user = fromCurrentUser ? formatMessage({ id: "YOU" }) : senderName;
  const formattedDate = formatDate(
    sentAt,
    SHORT_DATE_AND_TIME_FORMAT_NO_TIMEZONE
  );
  return /* @__PURE__ */ React23.createElement(
    Box13,
    {
      css: {
        borderColor: "transparent",
        borderStyle: "solid",
        borderWidth: "$thin",
        marginBottom: "$threeQuarters",
        width: "100%",
        "&:hover": {
          backgroundColor: "$highlightBackgroundSubdued"
        },
        "&:focus-within": {
          backgroundColor: "$highlightBackgroundSubdued",
          borderColor: displayFocusBorder ? "$interactiveFocusOuter" : "transparent"
        }
      }
    },
    /* @__PURE__ */ React23.createElement(Divider, { css: { marginY: "$none" } }),
    /* @__PURE__ */ React23.createElement(Box13, { css: { width: "100%" }, role: "gridcell" }, /* @__PURE__ */ React23.createElement(
      Box13,
      {
        css: {
          padding: "$one",
          // hide default styles as the container has focus within to indicate focus of the whole row
          '&[class*="GDS"]:focus': {
            outline: "none",
            boxShadow: "none"
          }
        },
        tabIndex: hasFocus ? 0 : -1,
        ref: cellRef
      },
      /* @__PURE__ */ React23.createElement(StyledTextWrapper2, null, /* @__PURE__ */ React23.createElement(
        Box13,
        {
          css: {
            marginBottom: "$threeQuarters",
            display: "flex",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ React23.createElement(
          Avatar2,
          {
            userInitials: initials,
            imageSrc: photoUrl,
            width: "two",
            height: "two",
            fontSize: "caption",
            marginInlineEnd: "half"
          }
        ),
        /* @__PURE__ */ React23.createElement(Box13, null, /* @__PURE__ */ React23.createElement(UtilityText4, { emphasis: "emphasized" }, user), /* @__PURE__ */ React23.createElement(ParagraphText3, { size: "xs" }, formattedDate))
      ), text && /* @__PURE__ */ React23.createElement(ParagraphText3, null, /* @__PURE__ */ React23.createElement(
        MessageTextWithInlineLinks,
        {
          text,
          fromCurrentUser
        }
      )), messageDocuments == null ? void 0 : messageDocuments.map((document2) => /* @__PURE__ */ React23.createElement(React23.Fragment, { key: document2.downloadUrl }, /* @__PURE__ */ React23.createElement(VisuallyHidden5, null, formatMessage({ id: "WITH_DOCUMENT" })), /* @__PURE__ */ React23.createElement(Box13, { css: { marginTop: "$quarter" } }, /* @__PURE__ */ React23.createElement(
        MessageDocument,
        {
          document: document2,
          hasFocus,
          color: "onSurface.text.primary",
          fromCurrentUser,
          onFocus: () => setDisplayFocusBorder(false),
          onBlur: () => setDisplayFocusBorder(true),
          withBoxedStyling: true
        }
      )))))
    )),
    /* @__PURE__ */ React23.createElement(Divider, { css: { marginY: "$none" } })
  );
};

// src/pages/components/message/message.component.tsx
var MessageFromCurrentUser = ({
  messageDetails,
  hasFocus,
  gridRef,
  messagingStyle,
  sender
}) => /* @__PURE__ */ React24.createElement(Box14, { role: "row" }, messagingStyle === "boxed" ? /* @__PURE__ */ React24.createElement(
  MessageBoxed,
  {
    fromCurrentUser: true,
    hasFocus,
    messageDetails,
    gridRef,
    photoUrl: sender.photoUrl,
    initials: sender.initials
  }
) : /* @__PURE__ */ React24.createElement(
  MessageBubble,
  {
    backgroundColor: "primary.background.default",
    color: "onSurface.text.reversed",
    fromCurrentUser: true,
    hasFocus,
    messageDetails,
    gridRef
  }
));
var MessageFromOtherUser = ({
  messageDetails,
  previousMessageSenderId,
  nextMessageSenderId,
  hasFocus,
  isDifferentDateAsPrevious,
  isDifferentDateAsNext,
  sender,
  gridRef,
  messagingStyle
}) => {
  var _a, _b;
  const senderId = (_b = (_a = messageDetails == null ? void 0 : messageDetails.sender) == null ? void 0 : _a.data) == null ? void 0 : _b.id;
  const displaySenderName = isDifferentDateAsPrevious || previousMessageSenderId !== senderId;
  const displaySenderAvatar = isDifferentDateAsNext || nextMessageSenderId !== senderId;
  const { name, firstName, roleDisplayName, photoUrl, initials } = sender;
  const senderName = roleDisplayName ? `${firstName} ${initials.slice(-1)}., ${roleDisplayName}` : `${name}`;
  return /* @__PURE__ */ React24.createElement(Box14, { role: "row" }, /* @__PURE__ */ React24.createElement(Flex12, { alignItems: "flex-end", justifyContent: "flex-start" }, messagingStyle === "bubble" && /* @__PURE__ */ React24.createElement(Box14, { width: "two", marginInlineEnd: "one", marginBottom: "quarter" }, displaySenderAvatar && /* @__PURE__ */ React24.createElement(
    Avatar3,
    {
      userInitials: initials,
      imageSrc: photoUrl,
      width: "two",
      height: "two",
      fontSize: "caption"
    }
  )), /* @__PURE__ */ React24.createElement(Flex12, { flexDirection: "column", alignItems: "flex-start", width: "100%" }, displaySenderName && messagingStyle === "bubble" && /* @__PURE__ */ React24.createElement(LabelText, { fontWeight: "regular" }, senderName), messagingStyle === "boxed" ? /* @__PURE__ */ React24.createElement(
    MessageBoxed,
    {
      hasFocus,
      messageDetails,
      gridRef,
      photoUrl,
      initials,
      senderName
    }
  ) : /* @__PURE__ */ React24.createElement(
    MessageBubble,
    {
      backgroundColor: "surface.background.secondary",
      color: "onSurface.text.primary",
      hasFocus,
      messageDetails,
      sender,
      gridRef
    }
  ))));
};
var Message3 = ({
  messageDetails,
  previousMessageSenderId,
  nextMessageSenderId,
  hasFocus,
  isDifferentDateAsPrevious,
  isDifferentDateAsNext,
  sender,
  gridRef,
  messagingStyle
}) => {
  const { data: userProfileData } = useGetUserProfile();
  const currentUserId = userProfileData == null ? void 0 : userProfileData.user_id;
  const { id: senderId } = sender;
  if (currentUserId === senderId) {
    return /* @__PURE__ */ React24.createElement(
      MessageFromCurrentUser,
      {
        messageDetails,
        hasFocus,
        gridRef,
        messagingStyle,
        sender
      }
    );
  }
  return /* @__PURE__ */ React24.createElement(
    MessageFromOtherUser,
    {
      messageDetails,
      previousMessageSenderId,
      nextMessageSenderId,
      hasFocus,
      isDifferentDateAsPrevious,
      isDifferentDateAsNext,
      sender,
      gridRef,
      messagingStyle
    }
  );
};

// src/pages/components/messages-grid/messages-grid.component.tsx
var TimeBar = ({ messageDate }) => /* @__PURE__ */ React25.createElement(Box15, { paddingY: "one" }, /* @__PURE__ */ React25.createElement(Flex13, { justifyContent: "center" }, /* @__PURE__ */ React25.createElement(BodyOneSecondary, { "data-testid": "formatted-date-bar" }, messageDate)));
var scrollToBottom = (scrollableEl, setDisplayUnreadButton) => {
  scrollableEl.scrollTop = scrollableEl.scrollHeight;
  setDisplayUnreadButton(false);
};
var MessagesGrid = ({
  threadMessages,
  threadDetails,
  fetchNextPage,
  isFetchingNextPage,
  isPaginationError,
  participants,
  showMobileMessageList,
  threadConfigOverride
}) => {
  const normalizedParticipants = useMemo4(
    () => normalizeParticipantsArray(participants),
    [participants]
  );
  const { formatMessage, formatDate } = useIntl19();
  const [displayUnreadButton, setDisplayUnreadButton] = useState5(false);
  const { data: userProfileData } = useGetUserProfile();
  const userId = userProfileData == null ? void 0 : userProfileData.user_id;
  const prevMessagesRef = React25.useRef(
    threadMessages[threadMessages.length - 1]
  );
  const { gridLabel, currentGridCell, gridRef } = useMessagesGrid({
    threadMessages,
    threadDetails,
    fetchNextPage,
    isFetchingNextPage,
    isPaginationError
  });
  const [configFromQuestionnaire] = useFhirResponseConfig();
  useEffect11(() => {
    if (gridRef.current) {
      scrollToBottom(gridRef.current, setDisplayUnreadButton);
    }
  }, [gridRef]);
  useEffect11(() => {
    if (!gridRef.current)
      return;
    const currentGridElement = gridRef.current;
    const scrollListener = () => {
      const { scrollTop, scrollHeight, offsetHeight } = currentGridElement;
      const atBottom = scrollTop + 5 >= scrollHeight - offsetHeight;
      if (atBottom) {
        setDisplayUnreadButton(false);
      }
    };
    currentGridElement.addEventListener("scroll", scrollListener);
    return () => currentGridElement.removeEventListener("scroll", scrollListener);
  }, [gridRef]);
  useEffect11(() => {
    if (!gridRef.current)
      return;
    const latestMessage = threadMessages[threadMessages.length - 1];
    if (prevMessagesRef.current.id === latestMessage.id)
      return;
    prevMessagesRef.current = latestMessage;
    trackMessagingAnalyticsEvent(EVENT_NAME8.SCREEN_LOADED, {
      screen_name: "message thread" /* MESSAGE_THREAD */
    });
    const currentGridElement = gridRef.current;
    const { scrollTop, scrollHeight, offsetHeight } = currentGridElement;
    const atBottom = scrollTop === scrollHeight - offsetHeight;
    if (atBottom)
      return;
    const fromCurrentUser = userId === latestMessage.sender.data.id;
    if (fromCurrentUser) {
      scrollToBottom(currentGridElement, setDisplayUnreadButton);
    } else {
      setDisplayUnreadButton(true);
    }
  }, [threadMessages, gridRef, userId]);
  const { messagingStyle: defaultMessagingStyle } = useGetMessagingStyle();
  const messagingStyle = useMemo4(
    () => getConfigOverride({
      defaultConfigValue: defaultMessagingStyle,
      configName: "MESSAGING_THREAD_UI_STYLE",
      fhirResponseConfigs: configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      threadConfigs: threadConfigOverride,
      format: "string"
    }),
    [
      configFromQuestionnaire == null ? void 0 : configFromQuestionnaire.data,
      defaultMessagingStyle,
      threadConfigOverride
    ]
  );
  const isBubbleStyle = messagingStyle === "bubble";
  const isBoxedStyle = messagingStyle === "boxed";
  return /* @__PURE__ */ React25.createElement(
    Box15,
    {
      ref: gridRef,
      role: "grid",
      "aria-label": gridLabel,
      flexShrink: "1",
      flexGrow: "1",
      flexBasis: "10px",
      overflowY: showMobileMessageList ? "hidden" : "auto",
      paddingX: isBoxedStyle ? "none" : { _: "half", phone: "twoAndHalf" },
      paddingY: "two"
    },
    /* @__PURE__ */ React25.createElement(
      GridPaginationHandler,
      {
        isFetchingNextPage,
        isPaginationError,
        fetchNextPage
      }
    ),
    threadMessages.map((individualMessageDetails, index, arr) => {
      const {
        sender,
        previousMessageSenderId,
        nextMessageSenderId,
        displayTimeBar,
        isDifferentDateIncoming,
        currentFormattedTimestamp
      } = getMessageProps({
        normalizedParticipants,
        individualMessageDetails,
        individualMessageIndex: index,
        formatMessage,
        formatDate,
        threadMessages: arr
      });
      return /* @__PURE__ */ React25.createElement(Box15, { key: individualMessageDetails.id }, displayTimeBar && isBubbleStyle && /* @__PURE__ */ React25.createElement(TimeBar, { messageDate: currentFormattedTimestamp }), /* @__PURE__ */ React25.createElement(
        Message3,
        {
          key: individualMessageDetails.id,
          messageDetails: individualMessageDetails,
          previousMessageSenderId,
          nextMessageSenderId,
          hasFocus: currentGridCell.row === index,
          isDifferentDateAsPrevious: displayTimeBar,
          isDifferentDateAsNext: isDifferentDateIncoming,
          sender,
          gridRef,
          messagingStyle
        }
      ));
    }),
    displayUnreadButton && /* @__PURE__ */ React25.createElement(Flex13, { justifyContent: "center", position: "sticky", bottom: "0" }, /* @__PURE__ */ React25.createElement(
      SecondaryButton2,
      {
        onClick: () => {
          if (gridRef.current) {
            scrollToBottom(gridRef.current, setDisplayUnreadButton);
          }
        },
        backgroundColor: "surface.background.primary"
      },
      /* @__PURE__ */ React25.createElement(Flex13, { as: "span", alignItems: "center" }, /* @__PURE__ */ React25.createElement(Flex13, { as: "span", alignItems: "center", marginInlineEnd: "quarter" }, /* @__PURE__ */ React25.createElement(Icon, { icon: "interfaceChevronDown" })), formatMessage({ id: "UNREAD_MESSAGES" }))
    ))
  );
};

// src/hooks/use-message-body-details.hook.ts
import { useParamsLegacy as useParams6 } from "@leagueplatform/routing";

// src/hooks/use-all-messages-for-thread.hook.ts
import { useInfiniteQuery as useInfiniteQuery2 } from "@tanstack/react-query";
import {
  getMessagesForThread,
  THREAD_MESSAGES_PATH as THREAD_MESSAGES_PATH4
} from "@leagueplatform/messaging-api";
import { captureMessage } from "@leagueplatform/observability";
var useAllMessagesForThread = (threadId) => useInfiniteQuery2(
  [THREAD_MESSAGES_PATH4, threadId],
  ({ pageParam }) => getMessagesForThread(threadId, pageParam),
  {
    getNextPageParam: (lastPage) => {
      if (!lastPage.links.next || !lastPage.data.length) {
        return void 0;
      }
      const { next } = lastPage.links;
      return next.slice(next.indexOf("/v1/"));
    },
    onSuccess: (data) => {
      const totalMessages = data.pages.reduce(
        (total, page) => total + page.data.length,
        0
      );
      if (totalMessages >= 400) {
        captureMessage(
          `Chat with too many messages, tab navigation might be slow`,
          {
            severityLevel: "warning",
            tags: {
              totalMessages
            },
            context: {
              Context: {
                "Total Messages": `${totalMessages} messages`
              }
            }
          }
        );
      }
    }
  }
);

// src/hooks/use-message-body-details.hook.ts
var useMessageBodyDetails = () => {
  var _a, _b, _c;
  const { threadId } = useParams6();
  const {
    data: threadDetailsData,
    isLoading: isLoadingThreadDetails,
    error: threadDetailsError
  } = useMessageThreadDetails(threadId);
  const {
    fetchNextPage,
    isFetchingNextPage,
    data: threadMessageData,
    isLoading: isLoadingThreadMessageData,
    error: threadMessageDataError
  } = useAllMessagesForThread(threadId);
  const isMessageBodyLoading = isLoadingThreadMessageData || isLoadingThreadDetails;
  let flattenedThreadMessages;
  if (threadMessageData == null ? void 0 : threadMessageData.pages) {
    flattenedThreadMessages = threadMessageData.pages.reduce(
      (acc, { data: messageData }) => acc.concat(messageData),
      []
    );
  }
  const isMessageClosed = (threadMessageData == null ? void 0 : threadMessageData.pages) && ((_b = (_a = threadMessageData == null ? void 0 : threadMessageData.pages[threadMessageData.pages.length - 1]) == null ? void 0 : _a.meta) == null ? void 0 : _b.isClosed);
  const threadConfigOverride = (_c = threadDetailsData == null ? void 0 : threadDetailsData.meta) == null ? void 0 : _c.overrideConfigurations;
  return {
    fetchNextPage,
    isFetchingNextPage,
    threadDetailsData,
    threadMessageData: flattenedThreadMessages == null ? void 0 : flattenedThreadMessages.reverse(),
    isMessageBodyLoading,
    threadMessageDataError,
    threadDetailsError,
    isMessageClosed,
    threadConfigOverride
  };
};

// src/pages/components/message-body/message-body.component.tsx
var ERROR_MAX_WIDTH2 = "60%";
var MessageBody = ({
  showMobileMessageList,
  isDraftThread,
  draftThread,
  resetDraftState
}) => {
  const {
    fetchNextPage,
    isFetchingNextPage,
    threadDetailsData,
    threadMessageData,
    isMessageBodyLoading,
    threadMessageDataError,
    threadDetailsError,
    isMessageClosed,
    threadConfigOverride
  } = useMessageBodyDetails();
  const [, setPageError] = usePageError();
  const { formatMessage } = useIntl20();
  if (isMessageBodyLoading) {
    return /* @__PURE__ */ React26.createElement(
      Flex14,
      {
        height: "100%",
        justifyContent: "center",
        color: "decorative.brand.primary.default"
      },
      /* @__PURE__ */ React26.createElement(Spinner4, { isLoading: true })
    );
  }
  const isPaginationError = !!threadMessageData && threadMessageDataError && !!(threadDetailsData == null ? void 0 : threadDetailsData.data);
  if (isPaginationError) {
    return /* @__PURE__ */ React26.createElement(
      MessagesGrid,
      {
        threadMessages: threadMessageData,
        threadDetails: threadDetailsData.data,
        fetchNextPage,
        isFetchingNextPage,
        isPaginationError: true,
        key: threadDetailsData.data.id,
        participants: threadDetailsData.data.participants.data,
        showMobileMessageList,
        threadConfigOverride
      }
    );
  }
  const isThreadDetailsError = threadDetailsError || !(threadDetailsData == null ? void 0 : threadDetailsData.data);
  const isFetchingMessageDataError = threadMessageDataError || !threadMessageData;
  if (isThreadDetailsError || isFetchingMessageDataError) {
    setPageError(isThreadDetailsError || isFetchingMessageDataError);
    const errorImage = handleStaticAsset8(
      "MESSAGING_ERROR" /* MESSAGING_ERROR */
    );
    return /* @__PURE__ */ React26.createElement(Flex14, { alignItems: "center", justifyContent: "center", height: "100%" }, /* @__PURE__ */ React26.createElement(Box16, { maxWidth: ERROR_MAX_WIDTH2 }, /* @__PURE__ */ React26.createElement(
      ErrorState3,
      {
        imageSrc: errorImage,
        hideButton: true,
        headingString: formatMessage({ id: "GENERIC_MESSAGING_ERROR" }),
        error: threadMessageDataError
      }
    )));
  }
  const threadDetails = threadDetailsData.data;
  return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(
    MessagesGrid,
    {
      threadMessages: threadMessageData,
      threadDetails,
      fetchNextPage,
      isFetchingNextPage,
      key: threadDetailsData.data.id,
      participants: threadDetailsData.data.participants.data,
      showMobileMessageList,
      threadConfigOverride
    }
  ), /* @__PURE__ */ React26.createElement(
    ComposeForm,
    {
      isDraftThread,
      draftThread,
      messageClosed: isMessageClosed,
      resetDraftState,
      threadConfigOverride
    }
  ));
};

// src/pages/components/message-body-wrapper/message-body-wrapper.component.tsx
var EmptyThreadText = () => {
  useEffect12(() => {
    trackMessagingAnalyticsEvent(EVENT_NAME9.SCREEN_LOADED, {
      screen_name: "message thread" /* MESSAGE_THREAD */
    });
  }, []);
  return /* @__PURE__ */ React27.createElement(Flex15, { justifyContent: "center", padding: "one", flex: "1" }, /* @__PURE__ */ React27.createElement(Box17, null));
};
var MessageBodyWrapper = ({
  showMobileMessageList,
  isDraftThread,
  draftThread,
  resetDraftState
}) => {
  const { threadId } = useParams7();
  return threadId ? /* @__PURE__ */ React27.createElement(
    MessageBody,
    {
      showMobileMessageList,
      isDraftThread,
      draftThread,
      resetDraftState
    }
  ) : /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(EmptyThreadText, null), /* @__PURE__ */ React27.createElement(
    ComposeForm,
    {
      isDraftThread,
      draftThread,
      resetDraftState
    }
  ));
};

// src/pages/components/details-sidebar/details-sidebar.component.tsx
import React29, { useEffect as useEffect13 } from "react";
import { useParamsLegacy as useParams8 } from "@leagueplatform/routing";
import {
  Flex as Flex17,
  Box as Box19,
  QuietButton as QuietButton2,
  VisuallyHidden as VisuallyHidden6,
  HeadingThree as HeadingThree3,
  Spinner as Spinner5,
  css as css7,
  genesisStyled as genesisStyled10
} from "@leagueplatform/genesis-commons";
import { Modal, ICONS, Icon as Icon2 } from "@leagueplatform/ui-kit";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import { ErrorState as ErrorState4 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME10 } from "@leagueplatform/analytics";

// src/pages/components/details-sidebar/sidebar-members-list/sidebar-members-list.component.tsx
import React28 from "react";
import {
  BodyOne as BodyOne6,
  Caption as Caption2,
  Box as Box18,
  Flex as Flex16,
  genesisStyled as genesisStyled9
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import { Avatar as Avatar4 } from "@leagueplatform/web-common-components";
var StyledList = genesisStyled9(Flex16)`
  & > li:last-child {
    border-bottom: 0px;
  }
`;
var SidebarMembersList = ({
  participants
}) => {
  const { formatMessage } = useIntl21();
  return /* @__PURE__ */ React28.createElement(
    StyledList,
    {
      as: "ol",
      flexDirection: "column",
      "aria-label": formatMessage({ id: "MEMBERS" })
    },
    participants.map((participant) => {
      const { id, name, roleDisplayName, initials, photoUrl } = participant;
      return /* @__PURE__ */ React28.createElement(
        Flex16,
        {
          as: "li",
          alignItems: "center",
          borderBottomColor: "onSurface.border.subdued",
          borderBottomWidth: "thin",
          borderBottomStyle: "solid",
          paddingY: "threeQuarters",
          key: id
        },
        /* @__PURE__ */ React28.createElement(Box18, { marginInlineEnd: "threeQuarters", minWidth: "48px" }, /* @__PURE__ */ React28.createElement(
          Avatar4,
          {
            userInitials: initials,
            imageSrc: photoUrl,
            width: "three",
            height: "three"
          }
        )),
        /* @__PURE__ */ React28.createElement(Flex16, { flexDirection: "column", justifyContent: "center" }, /* @__PURE__ */ React28.createElement(BodyOne6, null, name), roleDisplayName && /* @__PURE__ */ React28.createElement(Caption2, null, roleDisplayName))
      );
    })
  );
};

// src/pages/components/details-sidebar/details-sidebar.component.tsx
var MAX_SIDEBAR_WIDTH = "484px";
var OVERLAY_PADDING_TOP = "100px";
var DetailsSidebarHeading = genesisStyled10(HeadingThree3)(
  ({ theme }) => css7({
    [`@media screen and (max-width: ${theme.breakpoints.phone})`]: {
      hyphens: "auto"
    }
  })
);
var DetailsSidebarContents = () => {
  var _a, _b;
  const { threadId } = useParams8();
  const {
    data: threadData,
    isLoading,
    error: error2
  } = useMessageThreadDetails(threadId);
  const filteredParticipants = useRemoveCurrentUser(
    (_b = (_a = threadData == null ? void 0 : threadData.data) == null ? void 0 : _a.participants) == null ? void 0 : _b.data
  );
  const { formatMessage } = useIntl22();
  if (isLoading) {
    return /* @__PURE__ */ React29.createElement(
      Flex17,
      {
        alignItems: "center",
        justifyContent: "center",
        color: "decorative.brand.primary.default",
        height: "80%"
      },
      /* @__PURE__ */ React29.createElement(Spinner5, { isLoading: true })
    );
  }
  if (error2 || !(threadData == null ? void 0 : threadData.data)) {
    const errorImage = handleStaticAsset9(
      "MESSAGING_ERROR" /* MESSAGING_ERROR */
    );
    return /* @__PURE__ */ React29.createElement(Flex17, { alignItems: "center", justifyContent: "center", height: "80%" }, /* @__PURE__ */ React29.createElement(Box19, null, /* @__PURE__ */ React29.createElement(
      ErrorState4,
      {
        imageSrc: errorImage,
        hideButton: true,
        headingString: formatMessage({ id: "GENERIC_MESSAGING_ERROR" }),
        error: error2
      }
    )));
  }
  const {
    subject,
    participants: { data: participantsData }
  } = threadData.data;
  const userNames = getParticipantFirstNames(participantsData);
  return /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(Flex17, { flexDirection: "column", alignItems: "center", width: "100%" }, /* @__PURE__ */ React29.createElement(ParticipantsAvatar, { participants: filteredParticipants }), /* @__PURE__ */ React29.createElement(
    DetailsSidebarHeading,
    {
      padding: "half",
      paddingBottom: "oneAndHalf",
      textAlign: "center"
    },
    subject || userNames.join(", ")
  )), /* @__PURE__ */ React29.createElement(
    Box19,
    {
      overflowY: "auto",
      flexGrow: 1,
      padding: { _: "half", phone: "oneAndHalf" }
    },
    /* @__PURE__ */ React29.createElement(SidebarMembersList, { participants: participantsData })
  ));
};
function DetailsSidebar({ onClose }) {
  const { formatMessage } = useIntl22();
  useEffect13(() => {
    trackMessagingAnalyticsEvent(EVENT_NAME10.SCREEN_LOADED, {
      screen_name: "thread details" /* THREAD_DETAILS */
    });
  }, []);
  return /* @__PURE__ */ React29.createElement(Modal.Wrapper, { options: {}, onClose }, /* @__PURE__ */ React29.createElement(
    Flex17,
    {
      position: "absolute",
      insetInlineEnd: "0",
      insetInlineStart: { _: "0", phone: "unset" },
      flexDirection: "column",
      maxWidth: MAX_SIDEBAR_WIDTH,
      width: "100%",
      "aria-labelledby": "details-sidebar",
      backgroundColor: "surface.background.primary",
      height: "100vh"
    },
    /* @__PURE__ */ React29.createElement(
      Flex17,
      {
        justifyContent: "flex-end",
        position: "relative",
        paddingTop: OVERLAY_PADDING_TOP
      },
      /* @__PURE__ */ React29.createElement(
        QuietButton2,
        {
          lineHeight: "caption",
          top: "half",
          insetInlineEnd: { _: "half", phone: "one" },
          paddingX: "half",
          paddingY: "half",
          onClick: () => onClose(false),
          position: "absolute"
        },
        /* @__PURE__ */ React29.createElement(VisuallyHidden6, null, formatMessage({ id: "CLOSE" })),
        /* @__PURE__ */ React29.createElement(Icon2, { icon: ICONS.CLOSE, size: 16, "aria-hidden": "true" })
      )
    ),
    /* @__PURE__ */ React29.createElement(DetailsSidebarContents, null)
  ));
}

// src/pages/components/threads-sidebar/threads-sidebar.component.tsx
import React33, { useState as useState6, useEffect as useEffect15 } from "react";
import {
  LinkLegacy as Link3,
  useLocationLegacy as useLocation3
} from "@leagueplatform/routing";
import { getModulePath as getModulePath2, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2 } from "@leagueplatform/core";
import {
  HeadingTwo as HeadingTwo3,
  Box as Box22,
  Flex as Flex20,
  BodyTwoSecondary as BodyTwoSecondary3
} from "@leagueplatform/genesis-commons";
import { BackButtonArrow } from "@leagueplatform/web-common-components";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME13 } from "@leagueplatform/analytics";
import { useGoBack } from "@leagueplatform/web-common";
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";
import {
  Button as Button4,
  queryHelpers as queryHelpers2,
  useMediaQuery as useMediaQuery2,
  UtilityText as UtilityText5,
  VisuallyHidden as VisuallyHidden9
} from "@leagueplatform/genesis-core";

// src/components/create-message-modal/create-message-modal.component.tsx
import React32, { useEffect as useEffect14 } from "react";
import { VisuallyHidden as VisuallyHidden8 } from "@leagueplatform/genesis-commons";
import { Icon as Icon3, Box as Box21, Button as Button3 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import { Modal as Modal2 } from "@leagueplatform/ui-kit";
import { EVENT_NAME as EVENT_NAME12 } from "@leagueplatform/analytics";

// src/components/participants-list/participants-list.component.tsx
import React31 from "react";
import { useNavigateLegacy as useNavigate3 } from "@leagueplatform/routing";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import {
  HeadingTwo as HeadingTwo2,
  HeadingFour as HeadingFour2,
  Box as Box20,
  Label as Label2,
  Flex as Flex19,
  PrimaryButton as PrimaryButton3,
  BodyTwoSecondary as BodyTwoSecondary2,
  VisuallyHidden as VisuallyHidden7,
  TextInput
} from "@leagueplatform/genesis-commons";
import {
  InputStatusMessage as InputStatusMessage2,
  ParagraphText as ParagraphText4
} from "@leagueplatform/genesis-core";
import { Formik as Formik2, Form as Form2, Field as Field3 } from "formik";

// src/hooks/use-get-thread-name-config.hook.ts
var useGetThreadNameConfig = () => {
  const { data } = useGetMessagingConfig();
  const getAttributeByName = (attrName) => {
    var _a, _b;
    const attrData = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.find(
      (config) => {
        var _a2;
        return ((_a2 = config == null ? void 0 : config.attributes) == null ? void 0 : _a2.name) === attrName;
      }
    );
    return (_b = attrData == null ? void 0 : attrData.attributes) == null ? void 0 : _b.value;
  };
  const maxThreadTitleLength = getAttributeByName("THREAD_TITLE_MAX_SIZE") ? Number(getAttributeByName("THREAD_TITLE_MAX_SIZE")) : void 0;
  return {
    maxThreadTitleLength
  };
};

// src/hooks/use-set-draft-thread.hook.ts
import { MESSAGING_THREADS_PATH as MESSAGING_THREADS_PATH10 } from "@leagueplatform/messaging-api";
import { useQueryClient as useQueryClient7 } from "@tanstack/react-query";
var useSetDraftThread = () => {
  const queryClient = useQueryClient7();
  const setDraftThread = (newDraftThread) => queryClient.setQueryData([MESSAGING_THREADS_PATH10, "draft"], newDraftThread);
  return setDraftThread;
};

// src/components/participants-list/participants-list.component.tsx
import { EVENT_NAME as EVENT_NAME11 } from "@leagueplatform/analytics";

// src/components/participants-list/participant-list-option.component.tsx
import React30 from "react";
import { Field as Field2 } from "formik";
import { useFocusFirstFormikError } from "@leagueplatform/web-common";
import {
  Label,
  Flex as Flex18,
  Checkbox,
  Caption as Caption3,
  css as css8,
  genesisStyled as genesisStyled11,
  ChoiceText
} from "@leagueplatform/genesis-commons";
var StyledListItem = genesisStyled11.li(
  css8({
    paddingY: "one",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomStyle: "solid",
    borderBottomWidth: "thin",
    "&:last-child": {
      borderBottom: "none"
    }
  })
);
var PARTICIPANTS_INPUT_NAME = "selectedParticipantIds";
var ParticipantListOption = ({
  participant
}) => {
  const labelRef = React30.useRef(null);
  const { id, name, roleDisplayName } = participant;
  const inputId = `careTeamInput${id}`;
  useFocusFirstFormikError();
  return /* @__PURE__ */ React30.createElement(StyledListItem, null, /* @__PURE__ */ React30.createElement(Label, { htmlFor: inputId, ref: labelRef }, /* @__PURE__ */ React30.createElement(Flex18, { display: "flex", justifyContent: "space-between" }, /* @__PURE__ */ React30.createElement(ChoiceText, null, name), /* @__PURE__ */ React30.createElement(
    Field2,
    {
      as: Checkbox,
      type: "checkbox",
      id: inputId,
      name: PARTICIPANTS_INPUT_NAME,
      value: id,
      onFocus: () => {
        var _a;
        (_a = labelRef.current) == null ? void 0 : _a.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }
  )), roleDisplayName && /* @__PURE__ */ React30.createElement(Caption3, { as: "span", color: "onSurface.text.subdued" }, roleDisplayName)));
};

// src/components/participants-list/participants-list.component.tsx
var BUTTON_MAX_WIDTH = 326;
var SUBJECT_INPUT_NAME = "messageSubject";
var SUBJECT_INPUT_ERROR_ID = "message-subject-error";
var validateForm = (values, formatMessage, textInputMaxLength) => {
  const errors = {};
  if (!values[PARTICIPANTS_INPUT_NAME].length) {
    errors[PARTICIPANTS_INPUT_NAME] = formatMessage({
      id: "SELECT_PARTICIPANT_ERROR"
    });
  }
  if (textInputMaxLength && values[SUBJECT_INPUT_NAME] && values[SUBJECT_INPUT_NAME].length > textInputMaxLength) {
    errors[SUBJECT_INPUT_NAME] = formatMessage(
      {
        id: "THREAD_SUBJECT_MAX_LENGTH_ERROR"
      },
      { maximum: textInputMaxLength }
    );
  }
  return errors;
};
var ParticipantsList = ({ closeModal }) => {
  const { formatMessage } = useIntl23();
  const searchParams = useSearchParams();
  const { data: contactsData } = useMessagingContacts();
  const { maxThreadTitleLength } = useGetThreadNameConfig();
  const navigate = useNavigate3();
  const setDraftThread = useSetDraftThread();
  const participantsList = contactsData.allIds.map(
    (id) => contactsData.byId[id]
  );
  const searchParam = searchParams.get("h") ? HOME_SEARCH_PARAM : "";
  const careadvisorIds = participantsList.filter((item) => item.role === "care-advisor").map((item) => item.id);
  const handleSubmit = (values) => {
    const participantIds = values[PARTICIPANTS_INPUT_NAME];
    const participantRelationshipsList = participantIds.map(
      (id) => ({ type: "participant", id })
    );
    setDraftThread({
      subject: values[SUBJECT_INPUT_NAME],
      participants: participantRelationshipsList,
      answers: []
    });
    const isCareAdvisorSelected = participantIds.some(
      (participantId) => careadvisorIds.includes(participantId)
    );
    trackMessagingAnalyticsEvent(EVENT_NAME11.BUTTON_CLICKED, {
      screen_name: "new message" /* NEW_MESSAGE */,
      detail: "create message",
      number_message_participants: participantIds.length,
      is_care_advisor_selected: isCareAdvisorSelected,
      is_subject_created: !!values[SUBJECT_INPUT_NAME]
    });
    navigate(MESSAGING_LINKS.getMessagingHome(searchParam));
    closeModal();
  };
  return /* @__PURE__ */ React31.createElement(Box20, null, /* @__PURE__ */ React31.createElement(HeadingTwo2, { paddingY: "one", paddingX: "half" }, formatMessage({ id: "NEW_MESSAGE" })), /* @__PURE__ */ React31.createElement(
    Formik2,
    {
      initialValues: {
        [SUBJECT_INPUT_NAME]: "",
        [PARTICIPANTS_INPUT_NAME]: [...careadvisorIds]
      },
      validate: (values) => validateForm(values, formatMessage, maxThreadTitleLength),
      onSubmit: handleSubmit
    },
    ({ errors }) => /* @__PURE__ */ React31.createElement(Form2, null, /* @__PURE__ */ React31.createElement(Box20, null, /* @__PURE__ */ React31.createElement(Label2, { paddingY: "one", paddingX: "half" }, /* @__PURE__ */ React31.createElement(
      BodyTwoSecondary2,
      {
        as: "span",
        display: "inline-block",
        marginBottom: "quarter"
      },
      formatMessage({ id: "MESSAGE_SUBJECT" })
    ), /* @__PURE__ */ React31.createElement(
      Field3,
      {
        as: TextInput,
        name: SUBJECT_INPUT_NAME,
        placeholder: formatMessage({
          id: "MESSAGE_SUBJECT_PLACEHOLDER"
        }),
        "aria-describedby": errors[SUBJECT_INPUT_NAME] ? SUBJECT_INPUT_ERROR_ID : void 0
      }
    ), errors[SUBJECT_INPUT_NAME] && /* @__PURE__ */ React31.createElement(
      InputStatusMessage2,
      {
        id: SUBJECT_INPUT_ERROR_ID,
        inputStatus: "error",
        statusIconLabel: formatMessage({ id: "ERROR" })
      },
      /* @__PURE__ */ React31.createElement(
        ParagraphText4,
        {
          as: "span",
          css: { typography: "$bodyTwo", color: "inherit" }
        },
        errors[SUBJECT_INPUT_NAME]
      )
    )), /* @__PURE__ */ React31.createElement("fieldset", null, /* @__PURE__ */ React31.createElement(HeadingFour2, { as: "legend", paddingY: "one", paddingX: "half" }, /* @__PURE__ */ React31.createElement("span", null, formatMessage({ id: "TO" })), errors[PARTICIPANTS_INPUT_NAME] && /* @__PURE__ */ React31.createElement(VisuallyHidden7, null, `${formatMessage({ id: "ERROR" })}: ${errors[PARTICIPANTS_INPUT_NAME]}`)), /* @__PURE__ */ React31.createElement(
      Flex19,
      {
        flexDirection: "column",
        height: "30vh",
        overflow: "auto",
        paddingX: "half"
      },
      /* @__PURE__ */ React31.createElement("ul", null, participantsList.map((participant) => /* @__PURE__ */ React31.createElement(
        ParticipantListOption,
        {
          key: participant.id,
          participant
        }
      ))),
      errors[PARTICIPANTS_INPUT_NAME] && /* @__PURE__ */ React31.createElement(
        InputStatusMessage2,
        {
          id: "participant-error",
          inputStatus: "error",
          statusIconLabel: formatMessage({ id: "ERROR" })
        },
        /* @__PURE__ */ React31.createElement(
          ParagraphText4,
          {
            as: "span",
            css: { typography: "$bodyTwo", color: "inherit" }
          },
          errors[PARTICIPANTS_INPUT_NAME]
        )
      )
    ))), /* @__PURE__ */ React31.createElement(
      Flex19,
      {
        flexDirection: "column",
        alignItems: "center",
        borderTopColor: "onSurface.border.subdued",
        borderTopStyle: "solid",
        borderTopWidth: "thin",
        justifyContent: "center",
        paddingY: "oneAndHalf"
      },
      /* @__PURE__ */ React31.createElement(
        PrimaryButton3,
        {
          maxWidth: BUTTON_MAX_WIDTH,
          type: "submit",
          width: "100%",
          paddingX: "half"
        },
        formatMessage({ id: "CREATE_MESSAGE" })
      )
    ))
  ));
};

// src/components/create-message-modal/create-message-modal.component.tsx
var MODAL_WIDTH = 485;
var CreateMessageModal = ({ closeModal }) => {
  const { formatMessage } = useIntl24();
  useEffect14(() => {
    trackMessagingAnalyticsEvent(EVENT_NAME12.SCREEN_LOADED, {
      screen_name: "new message" /* NEW_MESSAGE */
    });
  }, []);
  return /* @__PURE__ */ React32.createElement(Modal2.Wrapper, { onClose: closeModal, options: {} }, /* @__PURE__ */ React32.createElement(
    Box21,
    {
      css: {
        position: "relative",
        backgroundColor: "$surfaceBackgroundPrimary",
        borderRadius: "$medium",
        width: "100%",
        maxWidth: MODAL_WIDTH,
        paddingTop: "$one",
        paddingInlineStart: "$one",
        paddingInlineEnd: "$one"
      }
    },
    /* @__PURE__ */ React32.createElement(ParticipantsList, { closeModal }),
    /* @__PURE__ */ React32.createElement(
      Box21,
      {
        css: {
          position: "absolute",
          top: "$two",
          insetInlineEnd: "$threeQuarters"
        }
      },
      /* @__PURE__ */ React32.createElement(
        Button3,
        {
          onClick: () => {
            trackMessagingAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
              screen_name: "new message" /* NEW_MESSAGE */,
              detail: "exit"
            });
            closeModal();
          },
          quiet: true,
          priority: "secondary",
          size: "large",
          css: { padding: "$threeQuarters" }
        },
        /* @__PURE__ */ React32.createElement(VisuallyHidden8, null, formatMessage({ id: "CLOSE" })),
        /* @__PURE__ */ React32.createElement(Box21, { css: { display: "flex" } }, /* @__PURE__ */ React32.createElement(Icon3, { icon: "tinyClose", size: 16, "aria-hidden": true }))
      )
    )
  ));
};

// src/pages/components/threads-sidebar/threads-sidebar.component.tsx
var ThreadsSidebar = ({
  isThreadListEmpty = true,
  setShowMobileMessageList
}) => {
  const { formatMessage } = useIntl25();
  const { pathname } = useLocation3();
  const goBack = useGoBack();
  const initialModalState = pathname === MESSAGING_LINKS.getStartNewMessage();
  const [isModalOpen, setIsModalOpen] = useState6(initialModalState);
  const isTabletAndBelow = useMediaQuery2(queryHelpers2.down("laptop"));
  const { data: isQuestionnaireDisabled, isLoading: isLoadingFlag } = useFeatureFlagQuery4(DISABLE_MESSAGING_QUESTIONNAIRE);
  useEffect15(() => {
    if (setShowMobileMessageList && isModalOpen) {
      setShowMobileMessageList(false);
    }
  }, [isModalOpen, setShowMobileMessageList]);
  const handleCompose = () => {
    trackMessagingAnalyticsEvent(EVENT_NAME13.BUTTON_CLICKED, {
      screen_name: "messages" /* MESSAGES */,
      detail: "start a new message"
    });
    setIsModalOpen(true);
  };
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(
    Flex20,
    {
      as: "section",
      minWidth: "320px",
      flexDirection: "column",
      flex: isThreadListEmpty ? 1 : "unset",
      maxWidth: "100%",
      overflowY: "auto",
      paddingTop: isTabletAndBelow ? "one" : "none"
    },
    /* @__PURE__ */ React33.createElement(Box22, { paddingInlineStart: { _: "half", phone: "two" } }, /* @__PURE__ */ React33.createElement(
      BackButtonArrow,
      {
        as: Link3,
        onClick: goBack,
        height: "unset",
        paddingInlineEnd: "one",
        paddingTop: "half"
      }
    )),
    /* @__PURE__ */ React33.createElement(Box22, { as: "header", paddingX: { _: "half", phone: "two" } }, /* @__PURE__ */ React33.createElement(Flex20, { alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ React33.createElement(
      HeadingTwo3,
      {
        as: "h1",
        marginY: "one",
        marginInlineEnd: "two",
        id: GRID_LABEL_ID
      },
      formatMessage({ id: "MESSAGES" })
    ), isQuestionnaireDisabled ? /* @__PURE__ */ React33.createElement(
      Button4,
      {
        loading: isLoadingFlag,
        icon: "descriptiveCompose",
        onClick: handleCompose
      },
      /* @__PURE__ */ React33.createElement(VisuallyHidden9, null, formatMessage({ id: "COMPOSE_NEW_MESSAGE" })),
      /* @__PURE__ */ React33.createElement(
        UtilityText5,
        {
          css: { color: "inherit", fontWeight: "inherit" },
          "aria-hidden": "true"
        },
        formatMessage({ id: "COMPOSE" })
      )
    ) : /* @__PURE__ */ React33.createElement(
      Button4,
      {
        as: Link3,
        to: `${getModulePath2(LEAGUE_MODULE_NAMES2.messaging)}/thread`,
        onClick: handleCompose,
        icon: "descriptiveCompose"
      },
      /* @__PURE__ */ React33.createElement(VisuallyHidden9, null, formatMessage({ id: "COMPOSE_NEW_MESSAGE" })),
      /* @__PURE__ */ React33.createElement(
        UtilityText5,
        {
          css: { color: "inherit", fontWeight: "inherit" },
          "aria-hidden": "true"
        },
        formatMessage({ id: "COMPOSE" })
      )
    )), /* @__PURE__ */ React33.createElement(BodyTwoSecondary3, { marginY: "one" }, formatMessage({ id: "MESSAGE_THREADS_LIST_SUBTITLE" }))),
    /* @__PURE__ */ React33.createElement(ThreadsList, { isQuestionnaireDisabled })
  ), isModalOpen && isQuestionnaireDisabled && /* @__PURE__ */ React33.createElement(CreateMessageModal, { closeModal: () => setIsModalOpen(false) }));
};

// src/pages/messages-page.page.tsx
var sidebarStyles = {
  borderInlineEndColor: "onSurface.border.subdued",
  borderInlineEndWidth: "thin",
  borderInlineStartColor: "onSurface.border.subdued",
  borderInlineStartWidth: "thin",
  borderStyle: "solid",
  maxWidth: 452
};
var StyledLaptopSidebar = genesisStyled12(Flex21)(
  ({ theme, isThreadListEmpty }) => {
    const mobileStyles = isThreadListEmpty ? {
      flexGrow: 1,
      maxWidth: "100%"
    } : { display: "none" };
    return css9(__spreadProps(__spreadValues({}, sidebarStyles), {
      paddingTop: "two",
      [`@media screen and (max-width: ${theme.breakpoints.laptop})`]: __spreadValues({}, mobileStyles)
    }));
  }
);
var StyledMobileSidebar = genesisStyled12(Flex21)(
  ({ theme, showMobileMessageList }) => css9(__spreadProps(__spreadValues({
    width: "100%",
    display: "none"
  }, sidebarStyles), {
    position: "absolute",
    top: "0",
    bottom: "0",
    insetInlineStart: showMobileMessageList ? 0 : -452,
    backgroundColor: "interactive.background.default",
    zIndex: 99,
    transition: "inset-inline-start 0.4s ease",
    visibility: showMobileMessageList ? "visible" : "collapse",
    [`@media screen and (max-width: ${theme.breakpoints.laptop})`]: {
      display: "flex"
    }
  }))
);
var ERROR_MAX_WIDTH3 = "400px";
var MessagesPage = () => {
  const [showModal, setShowModal] = useState7(false);
  const [showMobileMessageList, setShowMobileMessageList] = useState7(false);
  const [, setConfig] = useFhirResponseConfig();
  const { threadId } = useParams9();
  const draftThread = useGetDraftThread();
  const deleteDraftThread = useDeleteDraftThread();
  const { formatMessage } = useIntl26();
  useDocumentTitle(
    formatMessage({ id: "MESSAGING_MESSAGES_LANDING_PAGE_TITLE" })
  );
  const threadContainerRef = useRef3(null);
  const {
    mutate,
    isLoading: isLoadingPostStartAsyncMessagingError,
    isError: hasPostStartAsyncMessagingError
  } = usePostStartAsyncMessaging();
  useEffect16(() => {
    trackMessagingAnalyticsEvent(EVENT_NAME14.SCREEN_LOADED, {
      screen_name: "messages" /* MESSAGES */
    });
  }, []);
  useEffect16(() => {
    if (draftThread.answers.length && !threadId) {
      mutate(draftThread.answers, {
        onSuccess: (data) => {
          setConfig(data);
        }
      });
    } else {
      setConfig(void 0);
    }
  }, [draftThread.answers, mutate, setConfig, threadId]);
  const [pageError] = usePageError();
  const navigate = useNavigate4();
  const searchParams = useSearchParams();
  const { threadsData, isLoading, isError, error: error2 } = useMessagesPage({
    numberOfThreads: 1
  });
  useNewMessageEvent();
  const flattenedThreadsData = getFlattenedThreadData(threadsData);
  const { data: isQuestionnaireDisabled } = useFeatureFlagQuery5(
    DISABLE_MESSAGING_QUESTIONNAIRE
  );
  const isDraftThread = isQuestionnaireDisabled ? !threadId && draftThread.participants.length > 0 : !threadId && draftThread.answers.length > 0;
  const searchParam = searchParams.get("h") ? HOME_SEARCH_PARAM : "";
  useEffect16(() => {
    setShowMobileMessageList(false);
  }, [threadId]);
  useEffect16(() => {
    if (!isDraftThread && !threadId && (flattenedThreadsData == null ? void 0 : flattenedThreadsData.length)) {
      const autoselectedRoute = MESSAGING_LINKS.getMessagesForThread(
        flattenedThreadsData[0].id,
        searchParam
      );
      navigate(autoselectedRoute, { replace: true });
    }
  }, [flattenedThreadsData, navigate, threadId, isDraftThread, searchParam]);
  if (isLoading || isLoadingPostStartAsyncMessagingError) {
    return /* @__PURE__ */ React34.createElement(
      Box23,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React34.createElement(Spinner6, { isLoading: true })
    );
  }
  if (isError || hasPostStartAsyncMessagingError || pageError) {
    const errorImage = handleStaticAsset10(
      "MESSAGING_ERROR" /* MESSAGING_ERROR */
    );
    return /* @__PURE__ */ React34.createElement(
      Box23,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React34.createElement(Box23, { css: { maxWidth: ERROR_MAX_WIDTH3 } }, /* @__PURE__ */ React34.createElement(
        ErrorState5,
        {
          imageSrc: errorImage,
          hideButton: true,
          headingString: formatMessage({ id: "GENERIC_MESSAGING_ERROR" }),
          error: error2
        }
      ))
    );
  }
  const isThreadListEmpty = !(flattenedThreadsData == null ? void 0 : flattenedThreadsData.length) && !isDraftThread;
  const displayMessageThreadDetails = !isThreadListEmpty && threadId || isDraftThread;
  return /* @__PURE__ */ React34.createElement(
    Box23,
    {
      css: {
        display: "flex",
        width: "100%",
        // maxiWidth is 1400 + 16. The 16 is added to account for an extra 6px margin on either side of the layout.
        // Previously focus states for the messageList items where being cut off.
        maxWidth: "1456px",
        marginX: "auto",
        marginY: 0,
        overflowY: "hidden",
        position: "absolute",
        inset: 0
      }
    },
    /* @__PURE__ */ React34.createElement(StyledLaptopSidebar, { isThreadListEmpty }, /* @__PURE__ */ React34.createElement(
      ThreadsSidebar,
      {
        setShowMobileMessageList,
        isThreadListEmpty
      }
    )),
    displayMessageThreadDetails && /* @__PURE__ */ React34.createElement(
      Flex21,
      {
        flexGrow: 1,
        flexBasis: "65%",
        flexDirection: "column",
        borderInlineEndColor: "onSurface.border.subdued",
        borderInlineEndWidth: "thin",
        borderStyle: "solid",
        tabIndex: -1,
        ref: threadContainerRef,
        "aria-live": "polite"
      },
      /* @__PURE__ */ React34.createElement(
        MessageHeader,
        {
          setIsDetailsOpen: setShowModal,
          draftSubject: draftThread.subject,
          draftParticipants: draftThread.participants,
          toggleMessageList: setShowMobileMessageList,
          showMobileMessageList
        }
      ),
      /* @__PURE__ */ React34.createElement(Flex21, { flexDirection: "column", flex: 1, position: "relative" }, /* @__PURE__ */ React34.createElement(StyledMobileSidebar, { showMobileMessageList }, /* @__PURE__ */ React34.createElement(
        ThreadsSidebar,
        {
          setShowMobileMessageList
        }
      )), /* @__PURE__ */ React34.createElement(
        MessageBodyWrapper,
        {
          showMobileMessageList,
          isDraftThread,
          draftThread,
          resetDraftState: () => {
            var _a;
            deleteDraftThread();
            (_a = threadContainerRef.current) == null ? void 0 : _a.focus();
          }
        }
      ))
    ),
    showModal && /* @__PURE__ */ React34.createElement(DetailsSidebar, { onClose: setShowModal })
  );
};

// src/pages/new-message-page.page.tsx
import React36, { useEffect as useEffect17, useRef as useRef4, useState as useState8 } from "react";
import {
  Box as Box25,
  Button as Button5,
  focusOutlineOuter as focusOutlineOuter2,
  HeadingText as HeadingText2,
  Spinner as Spinner7,
  styled as styled5
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle2, useGoBack as useGoBack2 } from "@leagueplatform/web-common";
import { DynamicFHIRForm } from "@leagueplatform/fhir-questionnaire";
import { LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES3, getModulePath as getModulePath3 } from "@leagueplatform/core";
import { useNavigateLegacy as useNavigate5 } from "@leagueplatform/routing";
import { EVENT_NAME as EVENT_NAME15 } from "@leagueplatform/analytics";
import { ErrorState as ErrorState6 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset11 } from "@leagueplatform/asset-config";

// src/components/slide.component.tsx
import React35, { useMemo as useMemo5 } from "react";
import { Box as Box24, Flex as Flex22, css as css10 } from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
var EASING = Object.freeze({
  IN_OUT_QUAD: `cubic-bezier(0.45, 0, 0.55, 1)`
});
var baseDurationMs = 150;
var TRANSITION_DURATION_MS = Object.freeze({
  SHORT: baseDurationMs,
  MEDIUM: baseDurationMs * 2,
  LONG: baseDurationMs * 3,
  XLONG: baseDurationMs * 4
});
var { MEDIUM, XLONG } = TRANSITION_DURATION_MS;
var { IN_OUT_QUAD } = EASING;
var TRANSITIONS = Object.freeze({
  PAGE: `${XLONG}ms ${IN_OUT_QUAD}`,
  HALF_PAGE: `${MEDIUM}ms ${IN_OUT_QUAD}`
});
var slideTransition = `transform ${TRANSITIONS.PAGE}, opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideTransition = `opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideStyles = css10({
  insetInlineStart: 0,
  transform: "none",
  transition: reducedMotionSlideTransition
});
var useSlideTransitionStyles = ({
  slideIndex,
  gap,
  activeIndex
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const slideStyles = css10({
    insetInlineStart: `calc(${slideIndex} * ${gap})`,
    transform: `translateX(calc(-${gap} * ${activeIndex}))`,
    transition: slideTransition
  });
  return useMemo5(
    () => prefersReducedMotion ? reducedMotionSlideStyles : slideStyles,
    [prefersReducedMotion, slideStyles]
  );
};
var Slide = ({
  children,
  gap = "100%",
  slideIndex,
  activeIndex
}) => {
  const slideTransitionStyles = useSlideTransitionStyles({
    gap,
    slideIndex,
    activeIndex
  });
  return /* @__PURE__ */ React35.createElement(
    Box24,
    {
      "aria-hidden": activeIndex !== slideIndex,
      css: slideTransitionStyles,
      height: "100%",
      opacity: Number(activeIndex === slideIndex),
      position: "absolute",
      top: 0,
      display: "flex",
      width: "100%"
    },
    children
  );
};

// src/hooks/use-get-messaging-questionnaire.hook.ts
import { useMutation as useMutation5 } from "@tanstack/react-query";
import { postGenerateQuestionnaire } from "@leagueplatform/messaging-api";
var useGetMessagingQuestionnaire = () => useMutation5(
  ({ questionnaireId, answers }) => postGenerateQuestionnaire({ questionnaireId, answers })
);

// src/hooks/use-post-questionnaire-next-node.hook.ts
import { postQuestionnaireNextNode } from "@leagueplatform/messaging-api";
import { useMutation as useMutation6 } from "@tanstack/react-query";
var usePostQuestionnaireNextNode = () => useMutation6((nextNodeId) => postQuestionnaireNextNode(nextNodeId));

// src/hooks/use-create-message-modal-with-fhir.hook.ts
var useCreateMessageModalWithFhir = () => {
  const generateQuestionnaireMutation = useGetMessagingQuestionnaire();
  const postNextNodeMutation = usePostQuestionnaireNextNode();
  return {
    generateQuestionnaireMutation,
    postNextNodeMutation
  };
};

// src/hooks/use-get-first-questionnaire-id-config.hook.ts
var useGetFirstQuestionnaireIdConfig = () => {
  const { data, isLoading, isError } = useGetMessagingConfig();
  const getAttributeByName = (attrName) => {
    var _a, _b;
    const attrData = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.find(
      (config) => {
        var _a2;
        return ((_a2 = config == null ? void 0 : config.attributes) == null ? void 0 : _a2.name) === attrName;
      }
    );
    return (_b = attrData == null ? void 0 : attrData.attributes) == null ? void 0 : _b.value;
  };
  const firstQuestionnaireId = getAttributeByName("FIRST_QUESTIONNAIRE_ID");
  return {
    firstQuestionnaireId,
    isLoading,
    isError
  };
};

// src/pages/new-message-page.page.tsx
var Wrapper = styled5(Box25, {
  backgroundColor: "$surfaceBackgroundTertiary",
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  inset: 0,
  overflowX: "hidden"
});
var Body = styled5(Box25, {
  flex: 1,
  paddingTop: "$threeQuarters"
});
var Footer = styled5(Box25, {
  display: "flex",
  flexGrow: 0,
  justifyContent: "center",
  paddingTop: "$oneAndHalf",
  paddingBottom: "$oneAndHalf"
});
var Slider = styled5(Box25, {
  display: "flex",
  position: "relative",
  flexGrow: 1,
  height: "100%",
  width: "100%",
  maxWidth: 632,
  margin: "0 auto"
});
var SlideWrap = styled5(Box25, {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  backgroundColor: "$surfaceBackgroundPrimary",
  padding: "$two",
  borderRadius: "$large",
  overflowY: "auto",
  "&&:focus": {
    outline: "none !important"
  },
  "&&:focus-visible": __spreadValues({}, focusOutlineOuter2)
});
var ErrorWrapper = styled5(SlideWrap, {
  justifyContent: "center",
  position: "absolute",
  inset: 0,
  zIndex: 9
});
var LoadingWrapper = styled5(Box25, {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%"
});
var NewMessagePage = () => {
  const { formatMessage } = useIntl27();
  const goBack = useGoBack2();
  const [pages, setPages] = useState8([]);
  const [isTransitioning, setIsTransitioning] = useState8(false);
  const [currentPage, setCurrentPage] = useState8(0);
  const [currentQuestionnaireId, setCurrentQuestionnaireId] = useState8("");
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState8([]);
  const [lastRequest, setLastRequest] = useState8(null);
  const formRefs = useRef4([]);
  const questionnaireContainerRef = useRef4(null);
  const setDraftThread = useSetDraftThread();
  const navigate = useNavigate5();
  useDocumentTitle2(
    formatMessage({ id: "MESSAGING_MESSAGING_QUESTIONNAIRE_PAGE_TITLE" })
  );
  const {
    error: messagingConfigError,
    isError: messagingConfigIsError,
    isLoading: messagingConfigIsLoading
  } = useGetMessagingConfig();
  useEffect17(() => {
    trackMessagingAnalyticsEvent(EVENT_NAME15.SCREEN_LOADED, {
      screen_name: "new message" /* NEW_MESSAGE */
    });
  }, []);
  useEffect17(() => {
    if (pages.length > 0) {
      setCurrentPage(pages.length - 1);
    }
  }, [pages]);
  const { firstQuestionnaireId = "" } = useGetFirstQuestionnaireIdConfig();
  const { generateQuestionnaireMutation, postNextNodeMutation } = useCreateMessageModalWithFhir();
  const nextStep = (data) => {
    setPages((current) => [...current, data]);
  };
  const setQuestionnaireData = (data, variables) => {
    setCurrentQuestionnaireId(variables.questionnaireId);
    nextStep(data);
  };
  const getQuestionnaireData = ({
    questionnaireId,
    answer
  }) => {
    setLastRequest({
      fn: getQuestionnaireData,
      data: {
        questionnaireId,
        answer
      }
    });
    generateQuestionnaireMutation.mutate(
      {
        questionnaireId,
        answers: answer ? [answer] : []
      },
      {
        onSuccess: (data, variables) => {
          var _a;
          setLastRequest(null);
          setQuestionnaireData(data, variables);
          (_a = questionnaireContainerRef.current) == null ? void 0 : _a.focus();
        }
      }
    );
  };
  useEffect17(() => {
    if (firstQuestionnaireId) {
      getQuestionnaireData({
        questionnaireId: firstQuestionnaireId,
        answer: null
      });
    }
  }, [firstQuestionnaireId]);
  const nextQuestionnaire = (answer) => {
    setLastRequest({
      fn: nextQuestionnaire,
      data: answer
    });
    setQuestionnaireAnswers((current) => [...current, answer]);
    postNextNodeMutation.mutate(currentQuestionnaireId, {
      onSuccess({ data }) {
        var _a, _b;
        setLastRequest(null);
        if ((_a = data == null ? void 0 : data.attributes) == null ? void 0 : _a.completed) {
          const newDraftThread = {
            subject: formatMessage({ id: "NEW_MESSAGE" }),
            participants: [],
            answers: [...questionnaireAnswers, answer]
            // Include the new answer
          };
          setDraftThread(newDraftThread);
          navigate(`${getModulePath3(LEAGUE_MODULE_NAMES3.messaging)}/threads`);
          return;
        }
        getQuestionnaireData({
          questionnaireId: (_b = data == null ? void 0 : data.attributes) == null ? void 0 : _b.nodeId,
          answer
        });
      }
    });
  };
  const addToRefs = (el) => {
    var _a;
    if (el && !((_a = formRefs.current) == null ? void 0 : _a.includes(el))) {
      formRefs.current.push(el);
    }
  };
  const prevStep = () => {
    var _a;
    if (!isTransitioning) {
      const previousPage = pages[currentPage - 1];
      setIsTransitioning(true);
      setCurrentQuestionnaireId((_a = previousPage == null ? void 0 : previousPage.data) == null ? void 0 : _a.id);
      setTimeout(() => {
        setPages(pages.slice(0, -1));
        setIsTransitioning(false);
      }, 500);
    }
  };
  const triggerFormSubmit = () => {
    var _a, _b, _c, _d;
    if (formRefs.current[currentPage]) {
      const event = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      const pageTitle = (_d = (_c = (_b = (_a = pages[currentPage]) == null ? void 0 : _a.data) == null ? void 0 : _b.attributes) == null ? void 0 : _c.response) == null ? void 0 : _d.title;
      trackMessagingAnalyticsEvent(EVENT_NAME15.BUTTON_CLICKED, {
        screen_name: "new message" /* NEW_MESSAGE */,
        detail: `${pageTitle} - Continue`
      });
      formRefs.current[currentPage].dispatchEvent(event);
    }
  };
  const isLoading = generateQuestionnaireMutation.isLoading || postNextNodeMutation.isLoading || messagingConfigIsLoading;
  const isError = generateQuestionnaireMutation.isError || postNextNodeMutation.isError || messagingConfigIsError;
  const errors = [
    generateQuestionnaireMutation.error,
    postNextNodeMutation.error,
    messagingConfigError
  ];
  const errorImage = handleStaticAsset11(
    "MESSAGING_ERROR" /* MESSAGING_ERROR */
  );
  const retryRequest = () => {
    lastRequest == null ? void 0 : lastRequest.fn(lastRequest == null ? void 0 : lastRequest.data);
  };
  return /* @__PURE__ */ React36.createElement(Wrapper, { className: "new-message-page-wrapper" }, /* @__PURE__ */ React36.createElement(Body, null, /* @__PURE__ */ React36.createElement(
    Button5,
    {
      onClick: goBack,
      priority: "secondary",
      icon: "tinyClose",
      hideLabel: true,
      quiet: true,
      size: "small",
      css: {
        position: "absolute",
        top: "$threeQuarters",
        insetInlineEnd: 40,
        zIndex: 1
      }
    },
    formatMessage({ id: "CLOSE" })
  ), /* @__PURE__ */ React36.createElement(Slider, null, isError && /* @__PURE__ */ React36.createElement(ErrorWrapper, null, /* @__PURE__ */ React36.createElement(ErrorState6, { hideButton: true, imageSrc: errorImage, error: errors })), isLoading && !pages.length && /* @__PURE__ */ React36.createElement(LoadingWrapper, null, /* @__PURE__ */ React36.createElement(Spinner7, { loading: true })), pages.map((page, index) => {
    var _a, _b, _c, _d;
    return /* @__PURE__ */ React36.createElement(
      Slide,
      {
        key: (_a = page.data) == null ? void 0 : _a.id,
        activeIndex: currentPage,
        gap: "120%",
        slideIndex: index
      },
      /* @__PURE__ */ React36.createElement(
        SlideWrap,
        {
          ref: questionnaireContainerRef,
          tabIndex: -1,
          className: "new-message-page-questionnaire-wrapper"
        },
        /* @__PURE__ */ React36.createElement(
          HeadingText2,
          {
            level: "1",
            size: "xl",
            css: { typography: "$overline" },
            emphasis: "subtle"
          },
          formatMessage({ id: "MESSAGE_CENTER" })
        ),
        /* @__PURE__ */ React36.createElement(
          DynamicFHIRForm,
          {
            FHIRQuestionnaire: (_d = (_c = (_b = pages[index]) == null ? void 0 : _b.data) == null ? void 0 : _c.attributes) == null ? void 0 : _d.response,
            setQuestionnaireAnswer: nextQuestionnaire,
            handleSubmitInParent: true,
            ref: addToRefs
          }
        )
      )
    );
  }))), /* @__PURE__ */ React36.createElement(Footer, { className: "new-message-page-footer" }, pages.length > 1 && /* @__PURE__ */ React36.createElement(
    Button5,
    {
      onClick: prevStep,
      quiet: true,
      priority: "secondary",
      css: {
        marginInlineEnd: "$one"
      }
    },
    formatMessage({ id: "GO_BACK" })
  ), !isError && /* @__PURE__ */ React36.createElement(Button5, { onClick: triggerFormSubmit, loading: isLoading }, formatMessage({ id: "CONTINUE" })), isError && /* @__PURE__ */ React36.createElement(Button5, { onClick: retryRequest }, formatMessage({ id: "RETRY" }))));
};

// src/messaging.routes.tsx
var MessagingRoutes = () => {
  const { data: isQuestionnaireDisabled } = useFeatureFlagQuery6(
    DISABLE_MESSAGING_QUESTIONNAIRE
  );
  return /* @__PURE__ */ React37.createElement(FhirResponseConfigContextProvider, null, /* @__PURE__ */ React37.createElement(PageErrorProvider, null, /* @__PURE__ */ React37.createElement(Routes, null, /* @__PURE__ */ React37.createElement(
    Route,
    {
      path: "thread",
      element: isQuestionnaireDisabled ? /* @__PURE__ */ React37.createElement(MessagesPage, null) : /* @__PURE__ */ React37.createElement(NewMessagePage, null)
    }
  ), /* @__PURE__ */ React37.createElement(Route, { path: "threads", element: /* @__PURE__ */ React37.createElement(MessagesPage, null) }), /* @__PURE__ */ React37.createElement(Route, { path: "threads/:threadId/*", element: /* @__PURE__ */ React37.createElement(MessagesPage, null) }), /* @__PURE__ */ React37.createElement(
    Route,
    {
      element: /* @__PURE__ */ React37.createElement(
        Navigate,
        {
          to: `${getModulePath4(LEAGUE_MODULE_NAMES4.messaging)}/threads`,
          replace: true
        }
      ),
      path: "/*"
    }
  ))));
};

// src/index.ts
initModule();
export {
  MESSAGING_LINKS,
  MessagingRoutes,
  RecentMessageThreads
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/messaging'] = window.leagueSDKsPresent['@leagueplatform/messaging'] || [];
    window.leagueSDKsPresent['@leagueplatform/messaging'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/messaging'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/messaging module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map